// Tela: Ciclo de estudos. O CicloAtivo é quem faz o cronômetro andar (publica no timerStore);
// o AppMain mantém o <Ciclo> montado e só escondido depois da primeira visita (keep-alive).
// Extraído de App.js sem alteração de comportamento.
import { splitByMidnight } from "../lib/dates";
import { useState, useEffect, useRef } from "react";
import React from "react";
import ReactDOM from "react-dom";
import { loadLS, saveLS } from "../lib/storage";
import { sb } from "../lib/supabase";
import { publishTimer, lockEnabled, lockPrime, lockSet, lockStop } from "../lib/timer";
import { EDITAL_FROM_CARGO, EDITAL_FROM_CONTEST, editalLeaves, editalStore, editalUpdate, useEditalProgress, useEditais, editalFlat, matchEditalDisc, sessTopicIds, ALL_MODES } from "../lib/edital";
import { hexToRgb, useIsMobile, useTheme } from "../lib/theme";
import { IconLabel, NavIcon } from "../components/icons";
import { appConfirm, appAlert } from "../lib/dialog";
import { minutesToHuman, timeToMinutes, formatTimer } from "../lib/format";
import { ADMIN_EMAILS, CONTEST_SUBJECTS, SUBJECT_COLORS, CONTEST_LIST } from "../lib/constants";
import { TacCorners, TacEyebrow, TickBar, ContestEmblem, StarLegendModal, StarRating } from "../components/ui";
import { playBlockCompleteSound, primeSound, playTimeUpAlert } from "../lib/sound";
import { calAddStudy } from "../lib/calendar";
import { SessionStartModal, SessionFinishModal } from "../components/session";
import { estrFor, sessAulaIds } from "../lib/estrategia";

// ── CICLO ────────────────────────────────────────────────────────────────────

function OtrosSubjectBuilder({ subjects, setSubjects, theme: t, savedTemplates=[], onSaveTemplate, onLoadTemplate, onDeleteTemplate }) {
  const [nameInput,     setNameInput]     = useState("");
  const [weightInput,   setWeightInput]   = useState("");
  const [tplName,       setTplName]       = useState("");
  const [showSaveForm,  setShowSaveForm]  = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);

  function addSubject() {
    const n = nameInput.trim();
    const w = parseInt(weightInput) || 10;
    if (!n) return;
    const idx = subjects.length;
    setSubjects(prev => [...prev, {
      name: n, weight: w,
      color: SUBJECT_COLORS[idx % SUBJECT_COLORS.length],
      selected: true, stars: 0
    }]);
    setNameInput(""); setWeightInput("");
  }

  function handleSave() {
    const name = tplName.trim();
    if (!name || !subjects.length) return;
    onSaveTemplate(name, subjects);
    setTplName(""); setShowSaveForm(false);
    appAlert(`O concurso "${name}" ficará disponível na próxima vez que você criar um ciclo.`, { title:"Concurso salvo" });
  }

  return (
    <div style={{marginBottom:"1rem"}}>
      {/* Template bar */}
      <div style={{display:"flex",gap:"0.5rem",marginBottom:"0.6rem",flexWrap:"wrap",alignItems:"center"}}>
        {savedTemplates.length > 0 && (
          <button onClick={()=>setShowTemplates(v=>!v)}
            style={{background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:7,padding:"0.35rem 0.8rem",color:t.textDim,fontSize:"0.75rem",cursor:"pointer"}}>
            📂 Carregar concurso salvo ({savedTemplates.length})
          </button>
        )}
        {subjects.length > 0 && (
          showSaveForm ? (
            <div style={{display:"flex",gap:"0.4rem",flex:1}}>
              <input value={tplName} onChange={e=>setTplName(e.target.value)} placeholder="Nome do concurso (ex: PCDF 2026)"
                style={{flex:1,background:t.bgInner,border:`1px solid ${t.ac}60`,borderRadius:7,padding:"0.35rem 0.7rem",color:t.text,fontSize:"0.78rem",outline:"none"}}
                onKeyDown={e=>e.key==="Enter"&&handleSave()} autoFocus/>
              <button onClick={handleSave} style={{background:t.ac,border:"none",borderRadius:7,padding:"0.35rem 0.8rem",color:t.mode==="dark"?"#060d1a":"#fff",fontSize:"0.75rem",fontWeight:700,cursor:"pointer"}}>Salvar</button>
              <button onClick={()=>setShowSaveForm(false)} style={{background:"transparent",border:`1px solid ${t.border}`,borderRadius:7,padding:"0.35rem 0.6rem",color:t.textDim,fontSize:"0.75rem",cursor:"pointer"}}>✕</button>
            </div>
          ) : (
            <button onClick={()=>setShowSaveForm(true)}
              style={{background:t.acDim,border:`1px solid ${t.ac}40`,borderRadius:7,padding:"0.35rem 0.8rem",color:t.ac,fontSize:"0.75rem",fontWeight:600,cursor:"pointer"}}>
              💾 Salvar este concurso
            </button>
          )
        )}
      </div>

      {/* Templates list */}
      {showTemplates && savedTemplates.length > 0 && (
        <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:10,padding:"0.7rem",marginBottom:"0.6rem",display:"flex",flexWrap:"wrap",gap:"0.4rem"}}>
          {savedTemplates.map(tpl=>(
            <div key={tpl.id} style={{display:"flex",alignItems:"center",gap:2}}>
              <button onClick={()=>{ onLoadTemplate(tpl); setShowTemplates(false); }}
                style={{background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:"7px 0 0 7px",padding:"0.3rem 0.8rem",color:t.textMid,fontSize:"0.78rem",cursor:"pointer",fontWeight:600}}>
                {tpl.name} <span style={{color:t.textFaint,fontSize:"0.65rem"}}>({tpl.subjects.length} mat.)</span>
              </button>
              <button onClick={()=>onDeleteTemplate(tpl.id)} title="Excluir"
                style={{background:"#ef444415",border:"1px solid #ef444440",borderRadius:"0 7px 7px 0",padding:"0.3rem 0.5rem",color:"#ef4444",fontSize:"0.72rem",cursor:"pointer",lineHeight:1}}>✕</button>
            </div>
          ))}
        </div>
      )}

      {/* Subject list */}
      <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:12,overflow:"hidden",marginBottom:"0.6rem"}}>
        {subjects.length === 0 ? (
          <div style={{padding:"1.5rem",textAlign:"center",color:t.textFaint,fontSize:"0.82rem"}}>
            Adicione as matérias do seu concurso abaixo 👇
          </div>
        ) : (
          <>
            <div style={{display:"grid",gridTemplateColumns:"2rem 1fr 8rem 5rem 2rem",padding:"0.55rem 1rem",borderBottom:`1px solid ${t.borderIn}`}}>
              {["","Matéria","Experiência","Questões",""].map((h,i)=><span key={i} style={{fontSize:"0.65rem",color:t.textFaint,textTransform:"uppercase",letterSpacing:"0.08em"}}>{h}</span>)}
            </div>
            {subjects.map((s,i)=>(
              <div key={i} style={{display:"grid",gridTemplateColumns:"2rem 1fr 8rem 5rem 2rem",padding:"0.6rem 1rem",borderBottom:i<subjects.length-1?`1px solid ${t.borderIn}`:"none",alignItems:"center"}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:s.color}}/>
                <span style={{fontSize:"0.83rem",color:t.textMid,fontWeight:600}}>{s.name}</span>
                <StarRating value={s.stars} onChange={v=>setSubjects(p=>p.map((x,j)=>j===i?{...x,stars:v}:x))}/>
                <span style={{fontSize:"0.8rem",color:t.textDim,paddingLeft:"0.5rem"}}>{s.weight}q</span>
                <button onClick={()=>setSubjects(p=>p.filter((_,j)=>j!==i))}
                  style={{background:"transparent",border:"none",color:"#ef4444",cursor:"pointer",fontSize:"0.8rem",padding:0}}>✕</button>
              </div>
            ))}
          </>
        )}
      </div>

      {/* Add row */}
      <div style={{display:"flex",gap:"0.5rem"}}>
        <input value={nameInput} onChange={e=>setNameInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addSubject()}
          placeholder="Nome da matéria"
          style={{flex:3,background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:8,padding:"0.55rem 0.75rem",color:t.text,fontSize:"0.83rem",outline:"none"}}/>
        <input type="number" value={weightInput} onChange={e=>setWeightInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addSubject()}
          placeholder="Total de questões"
          style={{flex:1,background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:8,padding:"0.55rem 0.75rem",color:t.text,fontSize:"0.83rem",outline:"none"}}/>
        <button onClick={addSubject}
          style={{background:t.ac,color:t.mode==="dark"?"#0a0f0b":"#fff",border:"none",borderRadius:8,padding:"0.55rem 1rem",fontWeight:700,fontSize:"0.82rem",cursor:"pointer"}}>+ Add</button>
      </div>
    </div>
  );
}

// ── STUDY RING 3D — anel "em pé", espesso, com o timer girando junto e cores que deixam claro
// o que já foi estudado (progresso) e o que já foi concluído ──────────────────────────────────
function StudyRing3D({ subjects, activeIdx, setActiveIdx, running, totalStudiedNow, phase, subject, timeLeft, remaining, t, size = 320, modeInfo, overtimeSec, sessionKind, topicLabel, completed }) {
  const containerRef = useRef(null);
  const sceneRef = useRef(null);

  // Inclinação sutil que segue o mouse (parallax) + leve balanço quando o mouse não está em cima.
  // Os ângulos ficam sempre pequenos, então o anel nunca "deita" de lado — continua de frente
  // pro usuário, só ganha profundidade e reage ao movimento do cursor.
  useEffect(() => {
    const el = containerRef.current;
    const scene = sceneRef.current;
    if (!el || !scene) return;
    let raf;
    let hovering = false;
    let mouseRX = 0, mouseRY = 0; // alvo vindo do mouse
    let curX = 0, curY = 0;
    let clock = 0;

    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const relX = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      const relY = ((e.clientY - rect.top) / rect.height) * 2 - 1;
      mouseRY = Math.max(-1, Math.min(1, relX)) * 22;
      mouseRX = -Math.max(-1, Math.min(1, relY)) * 14;
      hovering = true;
    };
    const onLeave = () => { hovering = false; };

    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);

    const loop = () => {
      clock += 16;
      const idleX = Math.sin(clock / 1900) * 3.5;
      const idleY = Math.sin(clock / 2500) * 5;
      const targetX = hovering ? mouseRX : idleX;
      const targetY = hovering ? mouseRY : idleY;
      curX += (targetX - curX) * 0.08;
      curY += (targetY - curY) * 0.08;
      if (scene) scene.style.transform = `rotateX(${curX}deg) rotateY(${curY}deg)`;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  // ── geometria do anel — igual à do anel original (mesmos ângulos/raios) ──
  const CX = size / 2, CY = size / 2, R_OUT = size * (140 / 320), R_IN = size * (100 / 320);
  const GAP = 0.04;
  const N = Math.max(1, subjects.length);
  const segAngle = (2 * Math.PI) / N;

  function makeArc(segIdx, ro, ri) {
    const start = segIdx * segAngle - Math.PI / 2 + GAP / 2;
    const end = (segIdx + 1) * segAngle - Math.PI / 2 - GAP / 2;
    const x1 = CX + ro * Math.cos(start), y1 = CY + ro * Math.sin(start);
    const x2 = CX + ro * Math.cos(end), y2 = CY + ro * Math.sin(end);
    const ix1 = CX + ri * Math.cos(start), iy1 = CY + ri * Math.sin(start);
    const ix2 = CX + ri * Math.cos(end), iy2 = CY + ri * Math.sin(end);
    const lg = segAngle - GAP > Math.PI ? 1 : 0;
    return `M${x1},${y1} A${ro},${ro} 0 ${lg},1 ${x2},${y2} L${ix2},${iy2} A${ri},${ri} 0 ${lg},0 ${ix1},${iy1} Z`;
  }
  function makeProgressArc(segIdx, prog, ro, ri) {
    if (prog <= 0) return null;
    const fullStart = segIdx * segAngle - Math.PI / 2 + GAP / 2;
    const fullEnd = (segIdx + 1) * segAngle - Math.PI / 2 - GAP / 2;
    const sweep = (fullEnd - fullStart) * Math.min(prog, 1);
    if (sweep <= 0) return null;
    const end = fullStart + sweep;
    const x1 = CX + ro * Math.cos(fullStart), y1 = CY + ro * Math.sin(fullStart);
    const x2 = CX + ro * Math.cos(end), y2 = CY + ro * Math.sin(end);
    const ix1 = CX + ri * Math.cos(fullStart), iy1 = CY + ri * Math.sin(fullStart);
    const ix2 = CX + ri * Math.cos(end), iy2 = CY + ri * Math.sin(end);
    const lg = sweep > Math.PI ? 1 : 0;
    return `M${x1},${y1} A${ro},${ro} 0 ${lg},1 ${x2},${y2} L${ix2},${iy2} A${ri},${ri} 0 ${lg},0 ${ix1},${iy1} Z`;
  }

  // Estado de cada matéria. Trilho opaco (nem parece "cheio") + preenchimento colorido
  // proporcional ao tempo estudado — desenhados IGUAIS em todas as camadas (frente e fundo),
  // pra profundidade do bloco nunca dar a impressão de que já foi tudo concluído.
  const trackFill  = t.bgInner;   // segue o tema (antes era um verde fixo)
  const trackHover = t.border;
  const segState = subjects.map((s, i) => {
    const isDone = (s.studiedSec || 0) >= s.blockMin * 60;
    const isActive = i === activeIdx;
    const segTotal = s.blockMin * 60;
    const segStudied = isActive ? totalStudiedNow : (s.studiedSec || 0);
    const segProgress = Math.max(0, Math.min(1, segStudied / Math.max(1, segTotal)));
    return { isDone, isActive, segProgress };
  });

  // Gera os paths de um "andar" do anel. interactive=true só na camada da frente
  // (clique, hover, ✓); as camadas de trás usam exatamente o mesmo desenho, sem
  // interação e sem contorno, só pra dar espessura sem borrar as bordas.
  function buildSegElements(interactive) {
    const els = [];
    subjects.forEach((s, i) => {
      const { isDone, isActive, segProgress } = segState[i];
      const isClickable = !running || i === activeIdx;
      if (isDone) {
        els.push(
          <path key={`base-${i}`} d={makeArc(i, R_OUT, R_IN)} fill={s.color}
            stroke={interactive ? s.color : "none"} strokeWidth={interactive ? 2.5 : 0}
            style={interactive ? { cursor: isClickable ? "pointer" : "not-allowed", opacity: isClickable ? 1 : 0.5, transition: "all 0.15s" } : undefined}
            onClick={interactive ? (() => isClickable && setActiveIdx(i)) : undefined}
          />
        );
      } else {
        els.push(
          <path key={`base-${i}`} d={makeArc(i, R_OUT, R_IN)} fill={trackFill}
            stroke={interactive ? ((isActive || segProgress > 0) ? s.color : s.color + "50") : "none"} strokeWidth={interactive ? ((isActive || segProgress > 0) ? 2.5 : 0.5) : 0}
            style={interactive ? { cursor: isClickable ? "pointer" : "not-allowed", opacity: isClickable ? 1 : 0.5, transition: "all 0.15s" } : undefined}
            onClick={interactive ? (() => isClickable && setActiveIdx(i)) : undefined}
            onMouseEnter={interactive ? (e => { if (isClickable) e.currentTarget.setAttribute("fill", trackHover); }) : undefined}
            onMouseLeave={interactive ? (e => { if (isClickable) e.currentTarget.setAttribute("fill", trackFill); }) : undefined}
          />
        );
        if (segProgress > 0) {
          const p = makeProgressArc(i, segProgress, R_OUT, R_IN);
          if (p) els.push(<path key={`prog-${i}`} d={p} fill={s.color} opacity={isActive ? 1 : 0.85} style={{ pointerEvents: "none" }} />);
        }
      }
    });
    if (interactive) {
      subjects.forEach((s, i) => {
        if (!segState[i].isDone) return;
        const mid = i * segAngle - Math.PI / 2 + segAngle / 2;
        const mr = (R_OUT + R_IN) / 2;
        const mx = CX + mr * Math.cos(mid), my = CY + mr * Math.sin(mid);
        els.push(
          <text key={`chk-${i}`} x={mx} y={my} textAnchor="middle" dominantBaseline="central"
            fontSize={13} fontWeight={900} fill="#fff" style={{ textShadow: "0 1px 2px rgba(0,0,0,0.5)", pointerEvents: "none" }}>✓</text>
        );
      });
    }
    return els;
  }

  // Espessura real: cópias idênticas do anel empilhadas atrás da camada frontal.
  // Como todas ficam de frente pro usuário (mesmo plano), o anel continua "em pé"
  // como antes — ao inclinar (mouse/idle), a perspectiva revela as bordas dessas
  // camadas, dando volume ao bloco sem borrar o desenho.
  const LAYERS = 8;
  const LAYER_GAP = 4;
  const backLayers = [];
  for (let layerIdx = LAYERS - 1; layerIdx >= 1; layerIdx--) {
    backLayers.push(layerIdx);
  }
  const frontZ = 2; // onde fica a tampa (camada frontal) e o timer, um pouco à frente do topo do bloco

  return (
    <div ref={containerRef} style={{ width: size, height: size, position: "relative", perspective: 1000, margin: "0 auto" }}>
      <div ref={sceneRef} style={{ position: "absolute", inset: 0, transformStyle: "preserve-3d", willChange: "transform" }}>

        {/* Camadas de trás — dão espessura ao anel (efeito extrudado), com o mesmo progresso da frente */}
        {backLayers.map(layerIdx => {
          const z = -layerIdx * LAYER_GAP;
          const brightness = 1 - layerIdx * 0.07;
          return (
            <svg key={`layer-${layerIdx}`} width={size} height={size} viewBox={`0 0 ${size} ${size}`}
              style={{ position: "absolute", inset: 0, transform: `translateZ(${z}px)`, filter: `brightness(${brightness})`, pointerEvents: "none" }}>
              {buildSegElements(false)}
            </svg>
          );
        })}

        {/* Camada frontal (tampa) — interativa: clique, hover, progresso e ✓ de concluído */}
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ position: "absolute", inset: 0, transform: `translateZ(${frontZ}px)` }}>
          {buildSegElements(true)}
        </svg>

        {/* Fundo do centro: faz parte da cena 3D e inclina junto com o anel */}
        <div style={{
          position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
          transform: `translateZ(${frontZ + 3}px)`, transformStyle: "preserve-3d", pointerEvents: "none",
        }}>
          <div style={{
            width: (R_IN - 4) * 2, height: (R_IN - 4) * 2, borderRadius: "50%",
            background: t.mode === "dark" ? t.bg : "#f0f5f1",
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
            boxShadow: t.mode === "dark" ? "0 8px 24px rgba(0,0,0,0.6)" : "0 8px 20px rgba(0,0,0,0.12)",
          }}>
          </div>
        </div>
      </div>
      {/* Textos do centro fora da cena 3D: ficam nítidos (sem tremer) enquanto o anel inclina */}
      <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
        <div style={{ width: (R_IN - 4) * 2, height: (R_IN - 4) * 2, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {sessionKind
              ? <span style={{ fontSize: Math.round(size * 0.034), fontWeight: 800, letterSpacing: 1.5, color: sessionKind === "revisao" ? "#60a5fa" : t.ac, marginBottom: 2 }}>{sessionKind === "revisao" ? "REVISÃO" : "PROGRESSÃO"}</span>
              : phase && <span style={{ fontSize: Math.round(size * 0.036), fontWeight: 800, letterSpacing: 1, color: phase === "REVISÃO" ? "#60a5fa" : subject.color, marginBottom: 2 }}>{phase}</span>}
            <span style={{ fontSize: Math.round(size * 0.037), color: t.textDim, marginBottom: 4, maxWidth: (R_IN - 16) * 2, textAlign: "center", lineHeight: 1.2 }}>{subject.name.length > 24 ? subject.name.slice(0, 24) + "…" : subject.name}</span>
            {completed && overtimeSec == null
              ? <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, margin: "4px 0" }}>
                  <span style={{ width: Math.round(size * 0.13), height: Math.round(size * 0.13), borderRadius: "50%", background: "#22c55e22", color: "#4ade80", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <svg width={Math.round(size * 0.075)} height={Math.round(size * 0.075)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
                  </span>
                  <span style={{ fontSize: Math.round(size * 0.05), fontWeight: 900, color: "#4ade80", letterSpacing: 1 }}>CONCLUÍDO</span>
                </span>
              : overtimeSec != null
              ? <span style={{ fontSize: Math.round(size * 0.088), fontWeight: 900, color: t.text, fontFamily: "monospace", lineHeight: 1.1 }}><span style={{ color: t.ac }}>+</span>{formatTimer(overtimeSec)}</span>
              : <span style={{ fontSize: Math.round(size * 0.095), fontWeight: 900, color: t.text, fontFamily: "monospace", lineHeight: 1.1 }}>{formatTimer(timeLeft !== null ? timeLeft : remaining)}</span>}
            {overtimeSec != null && <span style={{ fontSize: Math.round(size * 0.027), fontWeight: 800, letterSpacing: 1.2, color: "#fbbf24", marginTop: 3, padding: "1px 7px", borderRadius: 20, background: "rgba(251,191,36,0.12)" }}>TEMPO EXTRA</span>}
            {topicLabel && <span title={topicLabel} style={{ fontSize: Math.round(size * 0.032), color: t.textMid, marginTop: 6, maxWidth: (R_IN - 22) * 2, textAlign: "center", lineHeight: 1.3, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{topicLabel}</span>}
            {modeInfo
              ? <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: Math.round(size * 0.034), color: t.textDim, marginTop: 6, fontWeight: 600 }}><span style={{ color: t.ac, display: "flex" }}><NavIcon id={modeInfo.icon} size={Math.round(size * 0.045)} /></span>{modeInfo.label}</span>
              : (() => {
                const extraMin = completed ? Math.floor(Math.max(0, (subject.studiedSec || 0) - subject.blockMin * 60) / 60) : 0;
                return extraMin > 0
                  ? <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, marginTop: 4 }}>
                      <span style={{ fontSize: Math.round(size * 0.046), fontWeight: 800, color: t.text }}>{minutesToHuman(subject.blockMin + extraMin)}</span>
                      <span style={{ fontSize: Math.round(size * 0.027), fontWeight: 800, letterSpacing: 1, color: "#fbbf24", padding: "1px 8px", borderRadius: 20, background: "rgba(251,191,36,0.14)" }}>+{extraMin}MIN EXTRA</span>
                    </span>
                  : <span style={{ fontSize: Math.round(size * 0.032), color: t.textFaint, marginTop: 4 }}>{minutesToHuman(subject.blockMin)}</span>;
              })()}
        </div>
      </div>
    </div>
  );
}

function CicloAtivo({ uid, isAdmin, cycle, cargoLabel, onCalendarTime, onEdit, onNew, onDelete, onSaveTime, onAddStudiedSec, onAddTimerSec, theme: t }) {
  const isMobile = useIsMobile();
  const ringSize = isMobile ? Math.max(260, Math.min(360, (typeof window!=="undefined"?window.innerWidth:360) - 32)) : 370;
  // Depois de recarregar a página (F5), volta para a matéria da sessão em andamento (ou do tempo extra), em vez de cair na primeira.
  // Sem isso, o tempo que passou enquanto a página estava fechada era creditado à matéria errada.
  const [activeIdx, setActiveIdx]       = useState(() => {
    const n = (cycle.subjects || []).length;
    const ok = x => x && x.cycleId === cycle.id && Number.isInteger(x.idx) && x.idx >= 0 && x.idx < n;
    const ss = loadLS("sf_session", null), ot = loadLS("sf_overtime", null);
    return ok(ss) ? ss.idx : ok(ot) ? ot.idx : 0;
  });
  const [running, setRunning]           = useState(false); // always start false; mount effect restores
  const [testMode, setTestModeState]    = useState(() => !!isAdmin && !!loadLS("sf_testMode", false));   // só administrador
  const testRef = React.useRef(testMode);
  testRef.current = testMode;
  // ── Sessão de estudo (modo, assunto do edital, registro ao finalizar) ──
  const EDITAIS = useEditais();
  const [edData] = useEditalProgress(uid);
  const [session, setSessionState] = useState(() => { const x = loadLS("sf_session", null); return x && x.cycleId === cycle.id ? x : null; });
  const sessionRef = React.useRef(session);
  sessionRef.current = session;
  const setSession = x => { saveLS("sf_session", x); sessionRef.current = x; setSessionState(x); };
  const [startOpen, setStartOpen] = useState(false);
  const [finishOpen, setFinishOpen] = useState(null);   // { then: "start" | null }
  // Tempo extra: quando o tempo acaba, o cronômetro continua contando (+00:00:05) até a pessoa finalizar
  const [overtime, setOvertimeState] = useState(() => { const o = loadLS("sf_overtime", null); return o && o.cycleId === cycle.id ? o : null; });
  const otRef = React.useRef(overtime);
  otRef.current = overtime;
  const setOvertime = o => { saveLS("sf_overtime", o); otRef.current = o; setOvertimeState(o); };
  const [timeUp, setTimeUp] = useState(false);
  const [savedToast, setSavedToast] = useState(null);
  const [, setOtTick] = useState(0);
  const pendingOverRef = React.useRef(0);
  useEffect(() => {
    if (!overtime || !overtime.wall) return;
    const iv = setInterval(() => setOtTick(x => x + 1), 500);
    return () => clearInterval(iv);
  }, [overtime && overtime.wall]); // eslint-disable-line react-hooks/exhaustive-deps
  const otShown = overtime ? (overtime.acc || 0) + (overtime.wall ? Math.max(0, Math.floor((Date.now() - overtime.wall) / 1000)) : 0) : null;
  const [timeLeft, setTimeLeft]         = useState(null);
  // splitEnabled agora é um objeto com chave por bloco: {0: true, 1: false, ...}
  // A divisão revisão/avanço sobrevive ao F5 enquanto a mesma sessão estiver em andamento (senão o app achava que a revisão tinha acabado)
  const [splitInit] = useState(() => { const ss = loadLS("sf_session", null), x = loadLS("sf_split", null); return ss && x && x.cycleId === cycle.id && x.at === ss.at ? x : null; });
  const [splitEnabledMap, setSplitEnabledMap] = useState(() => (splitInit && splitInit.enabled) || {});
  const splitEnabled = splitEnabledMap[activeIdx] || false;
  const [splitRatio, setSplitRatio]     = useState(() => (splitInit && typeof splitInit.ratio === "number") ? splitInit.ratio : 1/3); // revisão / total
  // Base da divisão = tempo que ainda falta no bloco (congelada quando a revisão começa)
  const [splitBaseMap, setSplitBaseMap] = useState(() => (splitInit && splitInit.base) || {});
  const [editingSplit, setEditingSplit] = useState(null); // "revisao" | "avanco" | null
  const [splitInputVal, setSplitInputVal] = useState(""); // valor digitado, em minutos
  const intervalRef                     = useRef(null);
  const timerStartRef                   = useRef(null); // timeLeft value when running started
  const wallStartRef                    = useRef(null); // wall-clock ms when timer last started
  const [subjects, setSubjectsLocal]    = useState(cycle.subjects);
  
  // Função para toggle splitEnabled no bloco atual
  const toggleSplit = () => {
    const newValue = !splitEnabled;
    setSplitEnabledMap(prev => ({...prev, [activeIdx]: newValue}));
    
    // Atualizar timeLeft IMEDIATAMENTE ao ativar/desativar (apenas se timer parado)
    if (!running) {
      const totalSec = subject.blockMin * 60;
      const studiedSec = subject.studiedSec || 0;
      const remaining = Math.max(0, totalSec - studiedSec);
      const reviewSec = Math.round(remaining * splitRatio);
      setSplitBaseMap(m => ({ ...m, [activeIdx]: null }));
      setSplitPhase("revisao"); // ligar/desligar a divisão recomeça pela revisão

      if (newValue) {
        // Ativou divisão: mostrar tempo de revisão
        setTimeLeft(Math.min(reviewSec, remaining));
      } else {
        // Desativou divisão: voltar para tempo total
        setTimeLeft(remaining);
      }
    }
  };

  const subject  = subjects[activeIdx];
  const blockSec = subject.blockMin * 60;
  const edId   = EDITAL_FROM_CARGO[cycle.cargo] || EDITAL_FROM_CONTEST[cycle.contest] || null;
  const edObj  = EDITAIS && edId ? EDITAIS.find(e => e.id === edId) : null;
  const edFam  = edObj ? edObj.family : null;
  const discOf = name => (edObj ? matchEditalDisc(edObj, name) : null);
  const edDisc = discOf(subject.name);

  // Aplica o valor digitado manualmente (em minutos) pra revisão ou avanço,
  // recalculando o splitRatio a partir dele.
  function commitSplitInput() {
    // Na fase de avanço (revisão já feita), a nova divisão vale sobre o que ainda falta no bloco
    const restart = !running && splitPhase === "avanco";
    const totalSec = Math.max(1, restart ? remaining : splitBase);
    const mins = parseFloat(splitInputVal.replace(",", "."));
    if (!isNaN(mins) && mins >= 0 && editingSplit) {
      const enteredSec = Math.min(totalSec, Math.max(0, Math.round(mins * 60)));
      const newRatio = editingSplit === "revisao"
        ? enteredSec / totalSec
        : 1 - (enteredSec / totalSec);
      if (restart && newRatio > 0) {
        setSplitPhase("revisao");
        setSplitBaseMap(m => ({ ...m, [activeIdx]: null }));
      }
      setSplitRatio(Math.min(1, Math.max(0, newRatio)));

      // Atualizar timeLeft imediatamente, igual ao slider (só se parado)
      if (!running) {
        const reviewSec = Math.round(totalSec * newRatio);
        setTimeLeft(Math.min(reviewSec, remaining));
      }
    }
    setEditingSplit(null);
    setSplitInputVal("");
  }

  // Remaining seconds for the active subject = blockMin - already studied (floor 0)
  function remainingSec(idx) {
    const s = subjects[idx];
    return Math.max(0, s.blockMin * 60 - (s.studiedSec || 0));
  }
  
  // Atualizar timeLeft quando SLIDER de divisão mudar (apenas se timer parado)
  const prevSplitRatioRef = useRef(splitRatio);
  useEffect(() => {
    if (prevSplitRatioRef.current === splitRatio) return;
    prevSplitRatioRef.current = splitRatio;
    
    if (running || !splitEnabled) return;
    
    const totalSec = subject.blockMin * 60;
    const studiedSec = subject.studiedSec || 0;
    const remaining = Math.max(0, totalSec - studiedSec);
    // Revisão já concluída (fase de avanço) e o usuário mexeu na barra para revisar de novo:
    // volta para a fase de revisão, com a divisão calculada sobre o que ainda falta no bloco.
    let base = splitBase;
    if (splitPhase === "avanco" && splitRatio > 0) {
      setSplitPhase("revisao");
      setSplitBaseMap(m => ({ ...m, [activeIdx]: null }));
      base = remaining;
    }
    const reviewSec = Math.round(Math.max(1, base) * splitRatio);

    setTimeLeft(Math.min(reviewSec, remaining));
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dependências mantidas como estavam (mudar alteraria quando o efeito roda)
  }, [splitRatio, running, splitEnabled, subject]);


  // Request notification permission on mount
  useEffect(() => {
    // Safari do iPhone (fora do app instalado) não tem Notification — sem esta checagem a tela ficava branca
    try {
      if (typeof Notification !== "undefined" && Notification.permission === "default") {
        Notification.requestPermission();
      }
    } catch {}
  }, []);

  // Reset timer when switching subject — skip first render (mount restore handles that)
  const activeIdxMountedRef = React.useRef(false);
  useEffect(() => {
    if (!activeIdxMountedRef.current) { activeIdxMountedRef.current = true; return; }
    setRunning(false);
    startedRef.current = false;
    saveLS("sf_timerRunning", false);
    saveLS("sf_timerWallStart", null);
    setSplitPhase("revisao");
    setSplitBaseMap(m => ({ ...m, [activeIdx]: null }));
    setTimeLeft(remainingSec(activeIdx));
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dependências mantidas como estavam (mudar alteraria quando o efeito roda)
  }, [activeIdx]);

  useEffect(() => {
    // On mount: restore timer state. running starts as false so we can safely setRunning(true) here.
    const savedWall  = loadLS("sf_timerWallStart", null);
    const savedTL    = loadLS("sf_timerTimeLeft", null);
    const wasRunning = loadLS("sf_timerRunning", false);
    if (wasRunning && savedWall !== null && savedTL !== null) {
      const elapsed  = Math.floor((Date.now() - savedWall) / 1000);
      const restored = Math.max(0, savedTL - elapsed);
      if (elapsed > savedTL) pendingOverRef.current = elapsed - savedTL;   // tempo que passou do fim enquanto o app estava fechado
      // credit time that passed while away
      if (elapsed > 0) {
        const capped = Math.min(elapsed, savedTL);
        setTimeout(() => {
          if (!(isAdmin && loadLS("sf_testMode", false))) onAddTimerSec && onAddTimerSec(capped);
          commitTime(activeIdx, capped, false, false); // Não resetar, timer continua
        }, 0);
      }
      setTimeLeft(restored);
      timerStartRef.current = restored;
      wallStartRef.current  = Date.now();
      saveLS("sf_timerWallStart", Date.now()); saveLS("sf_timerTimeLeft", restored);   // o tempo já creditado não pode ser creditado de novo se a página recarregar outra vez
      setRunning(true); // safe: started as false, so [running] effect will fire
    } else {
      setTimeLeft(remainingSec(activeIdx));
    }
    // On unmount: stamp wallStart so next mount knows how much time passed
    return () => {
      saveLS("sf_timerWallStart", Date.now());
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dependências mantidas como estavam (mudar alteraria quando o efeito roda)
  }, []);

  // Persist running state changes — skip first render (mount restore handles initial state)
  const persistMountedRef = React.useRef(false);
  useEffect(() => {
    if (!persistMountedRef.current) { persistMountedRef.current = true; return; }
    saveLS("sf_timerRunning", running);
    if (running) {
      saveLS("sf_timerWallStart", Date.now());
      saveLS("sf_timerTimeLeft", timeLeft);
    } else {
      saveLS("sf_timerWallStart", null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dependências mantidas como estavam (mudar alteraria quando o efeito roda)
  }, [running]);

  // Presença para o Discord Rich Presence (só admin; lido por um programa local).
  useEffect(() => {
    let off = false, iv = null;
    // Cronômetro do Discord continua do tempo já estudado no bloco (não zera ao pausar/retomar).
    const startedAt = new Date(Date.now() - (subjects[activeIdx]?.studiedSec || 0) * 1000).toISOString();
    const push = async () => {
      try {
        const { data } = await sb.auth.getUser();
        const u = data?.user;
        if (off || !u || !ADMIN_EMAILS.includes(u.email)) return;
        const known = CONTEST_LIST.find(c => c.id === cycle.contest);
        await sb.from("study_presence").upsert({
          user_id: u.id, active: running,
          subject: running ? subjects[activeIdx]?.name || null : null,
          contest: known?.label || (cycle.contest ? String(cycle.contest).toUpperCase() : null),
          started_at: running ? startedAt : null,
          updated_at: new Date().toISOString(),
        }, { onConflict: "user_id" });
      } catch {}
    };
    push();
    if (running) iv = setInterval(push, 60000); // sinal de vida
    return () => { off = true; if (iv) clearInterval(iv); };
  }, [running, activeIdx]); // eslint-disable-line react-hooks/exhaustive-deps

  // Tick — wall-clock based to avoid drift. Recalculates from wallStart every interval.
  useEffect(() => {
    if (running) {
      // Quando inicia: usar timeLeft atual como ponto de partida
      const startTL = timeLeft ?? remainingSec(activeIdx);
      timerStartRef.current = startTL;
      wallStartRef.current = Date.now();
      
      intervalRef.current = setInterval(() => {
        const elapsed = Math.floor((Date.now() - wallStartRef.current) / 1000);
        const next = Math.max(0, timerStartRef.current - elapsed);
        saveLS("sf_timerTimeLeft", next);
        setTimeLeft(next);
        
        if (next <= 0) {
          clearInterval(intervalRef.current);
          setRunning(false);
          saveLS("sf_timerRunning", false);
          const over = Math.max(0, elapsed - (timerStartRef.current || 0), pendingOverRef.current || 0);
          pendingOverRef.current = 0;
          if (splitEnabled && splitPhase === "revisao" && advanceSec > 0) {
            playBlockCompleteSound();
            if (typeof Notification !== "undefined" && Notification.permission === "granted") {
              const now = new Date();
              const timeStr = `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
              try { new Notification("Revisão concluída!", { 
                body: `Hora de avançar no conteúdo novo! • ${timeStr}`,
                icon: "/g17_icon.png"
              }); } catch {}
            }
            commitTime(activeIdx, timerStartRef.current, true, false); // Não resetar, vai iniciar avanço
            timerStartRef.current = null;
            setSplitPhase("avanco");
            setTimeLeft(advanceSec);
            if (sessionRef.current) startOvertime(over);
          } else {
            commitTime(activeIdx, timerStartRef.current, true, true); // Resetar porque bloco terminou
            timerStartRef.current = null;
            if (sessionRef.current) startOvertime(over); else playBlockCompleteSound();
            if (typeof Notification !== "undefined" && Notification.permission === "granted") {
              const now = new Date();
              const timeStr = `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
              try { new Notification("Bloco concluído!", { 
                body: `${subjects[activeIdx].name} finalizado! • ${timeStr}`,
                icon: "/g17_icon.png"
              }); } catch {}
            }
          }
        }
      }, 250);
    } else {
      clearInterval(intervalRef.current);
      // Quando pausar: salvar o tempo decorrido mas NÃO resetar timeLeft
      if (timeLeft !== null && timerStartRef.current !== null && timeLeft < timerStartRef.current) {
        const elapsed = timerStartRef.current - timeLeft;
        if (elapsed > 0) commitTime(activeIdx, elapsed, true, false); // NÃO resetar timeLeft ao pausar
      }
      timerStartRef.current = null;
      wallStartRef.current = null;
    }
    return () => clearInterval(intervalRef.current);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dependências mantidas como estavam (mudar alteraria quando o efeito roda)
  }, [running]);

  function commitTime(idx, elapsedSec, fromTimer=false, resetTimeLeft=false) {
    if (elapsedSec <= 0) return;
    const inTest = testRef.current;                                        // modo teste: não vai para Calendário nem ranking
    if (!inTest) onCalendarTime && onCalendarTime(subjects[idx]?.name, elapsedSec); // vai para o Calendário
    setSubjectsLocal(prev => {
      const updated = prev.map((s,i) => i===idx ? {...s, studiedSec:(s.studiedSec||0)+elapsedSec} : s);
      onSaveTime(updated);
      
      // SÓ resetar timeLeft se for explicitamente pedido (quando timer terminar)
      if (resetTimeLeft) {
        const s = updated[idx];
        const newRemaining = Math.max(0, s.blockMin*60 - (s.studiedSec||0));
        setTimeLeft(newRemaining);
      }
      // Caso contrário, mantém timeLeft atual (importante para pause/resume)
      
      return updated;
    });
    if (inTest) return;
    onAddStudiedSec && onAddStudiedSec(elapsedSec);
    if (fromTimer) { onAddTimerSec && onAddTimerSec(elapsedSec); }
  }

  const totalSec    = subject.blockMin * 60;
  const studiedSec  = subject.studiedSec || 0;
  const remaining   = Math.max(0, totalSec - studiedSec);
  const tl          = timeLeft ?? remaining;

  // Mostra o tempo restante na aba do navegador enquanto o timer roda
  useEffect(() => {
    if (running) {
      const mm = String(Math.floor(tl / 60)).padStart(2, "0");
      const ss = String(tl % 60).padStart(2, "0");
      document.title = `${mm}:${ss} · ${subject.name}`;
    } else {
      document.title = "G17 App";
    }
  }, [running, tl, subject.name]);

  // Restaura o título original ao sair da tela de Ciclo
  useEffect(() => {
    return () => { document.title = "G17 App"; };
  }, []);
  
  // Progress: proporção do tempo total estudado
  // Só calcular tempo decorrido se timer ESTÁ RODANDO
  const timeElapsedInSession = running && timerStartRef.current !== null && timeLeft !== null
    ? (timerStartRef.current - timeLeft)
    : 0;
  const totalStudiedNow = studiedSec + timeElapsedInSession;
  
  const splitBase   = splitBaseMap[activeIdx] != null ? splitBaseMap[activeIdx] : remaining;
  const reviewSec   = Math.round(splitBase * splitRatio);
  const advanceSec  = splitBase - reviewSec;

  // Split phase logic: track which phase we're in
  const [splitPhase, setSplitPhase] = React.useState(() => (splitInit && splitInit.phase) || "revisao"); // "revisao" | "avanco"
  useEffect(() => {
    const ss = sessionRef.current;
    if (!ss) return;
    saveLS("sf_split", { cycleId: cycle.id, at: ss.at, enabled: splitEnabledMap, ratio: splitRatio, base: splitBaseMap, phase: splitPhase });
  }, [splitEnabledMap, splitRatio, splitBaseMap, splitPhase, session]); // eslint-disable-line react-hooks/exhaustive-deps
  const phase = splitEnabled
    ? (splitRatio >= 1 ? "REVISÃO" : splitRatio <= 0 ? "AVANÇO" : splitPhase === "revisao" ? "REVISÃO" : "AVANÇO")
    : null;

  // derived
  const totalStudied = subjects.reduce((a,s)=>a+(s.studiedSec||0),0);
  const totalTarget  = subjects.reduce((a,s)=>a+s.blockMin*60,0);

  // Iniciar / pausar (usado pelo botão da tela e pelo bloco flutuante)
  function toggleTimer(fromUI) {
    const ot = otRef.current;
    if (ot) { primeSound(); if (ot.wall) commitOvertime(true); else setOvertime({ ...ot, wall: Date.now() }); return; }
    if(tl===0 && !(splitEnabled && splitPhase==="revisao" && advanceSec>0)) return;
    if(!running) {
      const curKind = splitEnabled && splitPhase === "revisao" && tl > 0 && reviewSec > 0 ? "revisao" : "estudo";
      const ss = sessionRef.current;
      if (fromUI === true) {
        if (!ss) { setStartOpen(true); return; }
        if (ss.kind === "revisao" && curKind === "estudo") { setFinishOpen({ then: "start" }); return; }
      }
      if (!ss) setSession({ kind: curKind, mode: null, topic: null, disc: edDisc ? edDisc.id : null, fam: edFam, idx: activeIdx, cycleId: cycle.id, startStudied: subject.studiedSec || 0, at: Date.now() });
      startCore();
      return;
    }
    setRunning(false);
  }
  function startOvertime(overSec) {
    setOvertime({ cycleId: cycle.id, idx: activeIdx, wall: Date.now() - (overSec || 0) * 1000, acc: 0 });
    setTimeUp(true);
    playTimeUpAlert();
  }
  function commitOvertime(pauseIt) {
    const o = otRef.current;
    if (!o) return;
    const sec = o.wall ? Math.floor((Date.now() - o.wall) / 1000) : 0;
    if (sec > 0) commitTime(o.idx, sec, true, false);
    setOvertime(pauseIt ? { ...o, wall: null, acc: (o.acc || 0) + sec } : null);
  }
  function startCore() {
    primeSound();
    lockPrime(blockSec);
    if (splitEnabled && splitPhase === "revisao" && splitBaseMap[activeIdx] == null) setSplitBaseMap(m => ({ ...m, [activeIdx]: remaining }));
    if(timeLeft !== null && timeLeft > 0) { timerStartRef.current = timeLeft; setRunning(true); return; }
    if(splitEnabled && splitPhase==="avanco") { setTimeLeft(advanceSec); timerStartRef.current = advanceSec; setRunning(true); return; }
    if(splitEnabled && splitPhase==="revisao") { const s2=Math.min(reviewSec,remaining); setTimeLeft(s2); timerStartRef.current=s2; setRunning(true); return; }
    setTimeLeft(remaining); timerStartRef.current=remaining; setRunning(true);
  }
  function beginSession({ mode, topic, topics, estr }) {
    const curKind = splitEnabled && splitPhase === "revisao" && tl > 0 && reviewSec > 0 ? "revisao" : "estudo";
    setSession({ kind: curKind, mode, topic, ...(topics && topics.length ? { topics } : {}), estr: estr || null, disc: edDisc ? edDisc.id : null, fam: edFam, idx: activeIdx, cycleId: cycle.id, startStudied: subject.studiedSec || 0, at: Date.now() });
    setStartOpen(false);
    startCore();
  }
  function endSession() {
    if (otRef.current) commitOvertime(false);
    setTimeUp(false);
    setSession(null);
    setFinishOpen(null);
    startedRef.current = false;
    bumpStarted(x => x + 1);
  }
  // Descarta a sessão: tira o tempo dela do ciclo, do calendário e do ranking, não registra no edital
  // (histórico, assuntos, aulas) e deixa o cronômetro zerado para recomeçar.
  function discardSession() {
    appConfirm("O tempo desta sessão sai do ciclo, do calendário e do ranking, e nada é registrado no edital nem no histórico. O cronômetro volta ao início.", { title:"Descartar esta sessão?", confirmText:"Descartar", danger:true })
      .then(ok => {
        if (!ok) return;
        const ss = sessionRef.current;
        if (ss && sessMeasured > 0) adjustTime(ss.idx, -sessMeasured);
        endSession();
        setRunning(false);
        saveLS("sf_timerRunning", false); saveLS("sf_timerWallStart", null);
      });
  }
  function openFinish(then) {
    setTimeUp(false);
    if (otRef.current) commitOvertime(false);              // grava o tempo extra
    if (running) setRunning(false);                       // pausa: o tempo é gravado ao pausar
    setTimeout(() => setFinishOpen({ then: then || null }), 60);
  }
  const sessMeasured = session ? Math.max(0, (subjects[session.idx]?.studiedSec || 0) - (session.startStudied || 0)) : 0;
  // Ajuste manual do tempo da sessão (para mais ou para menos)
  function adjustTime(idx, delta) {
    if (!delta) return;
    if (delta > 0) commitTime(idx, delta, false, false);   // tempo a mais: ciclo e calendário, mas NÃO conta no ranking
    else {
      const d = Math.min(-delta, subjects[idx]?.studiedSec || 0);
      if (!d) return;
      if (!testRef.current) { onCalendarTime && onCalendarTime(subjects[idx]?.name, -d); onAddTimerSec && onAddTimerSec(-d); }
      setSubjectsLocal(prev => { const u = prev.map((x, i) => i === idx ? { ...x, studiedSec: Math.max(0, (x.studiedSec || 0) - d) } : x); onSaveTime(u); return u; });
    }
    if (idx === activeIdx && !splitEnabled) setTimeLeft(null);
  }
  function saveSession({ leaves, rating, sec, aulas = [] }) {
    const ss = sessionRef.current; if (!ss) return;
    const then = finishOpen && finishOpen.then;
    const measured = Math.max(0, (subjects[ss.idx]?.studiedSec || 0) - (ss.startStudied || 0));
    if (Math.abs(sec - measured) >= 60) adjustTime(ss.idx, sec - measured);
    {                                                       // o edital registra mesmo no modo teste (só ranking e calendário ficam de fora)
      const sd = ss.fam && ss.disc && edObj ? edObj.disc.find(x => x.id === ss.disc) : null;
      const plannedNodes = sd ? sessTopicIds(ss).map(id => editalFlat(sd.topics).find(x => x.node.id === id)?.node).filter(Boolean) : [];
      editalUpdate(p => {
        const k = id => `${ss.fam}:${ss.disc}:${id}`;
        const done = { ...(p.done || {}) }, prog = { ...(p.prog || {}) }, rate = { ...(p.rate || {}) }, rev = { ...(p.rev || {}) };
        const now = Date.now();
        if (sd) {
          if (ss.kind === "estudo") leaves.forEach(id => { if (!done[k(id)]) done[k(id)] = now; delete prog[k(id)]; });
          else leaves.forEach(id => { rev[k(id)] = now; });
          if (ss.kind === "estudo") plannedNodes.forEach(node => editalLeaves([node]).forEach(id => { if (!done[k(id)]) prog[k(id)] = 1; }));
          const rated = leaves.length ? leaves : plannedNodes.flatMap(node => editalLeaves([node]));
          if (rating) rated.forEach(id => { rate[k(id)] = { v: rating, at: now }; });
        }
        // Material do Estratégia (só administrador): aulas assistidas e em andamento, no mesmo registro do edital
        const ce = ss.estr;
        let course = p.course;
        if (ce && ce.slug) {
          const cd = { ...((p.course || {}).done || {}) }, cp = { ...((p.course || {}).prog || {}) };
          const ck = id => `${ce.slug}:${id}`;
          aulas.forEach(id => { if (!cd[ck(id)]) cd[ck(id)] = now; delete cp[ck(id)]; });
          sessAulaIds(ce).forEach(id => { if (!cd[ck(id)]) cp[ck(id)] = 1; });
          course = { ...(p.course || {}), done: cd, prog: cp };
        }
        const log = [{ ...(testRef.current ? { test: true } : {}), at: now, kind: ss.kind, mode: ss.mode, subj: subjects[ss.idx]?.name, fam: ss.fam, disc: ss.disc, topic: ss.topic, ...(sessTopicIds(ss).length > 1 ? { topics: sessTopicIds(ss) } : {}), sec, rating, n: leaves.length, ...(leaves.length ? { leafIds: leaves } : {}), ...(ce ? { estr: ce.slug, aulas: aulas.length, aulaIds: aulas, ...(sessAulaIds(ce).length ? { aulasPlan: sessAulaIds(ce) } : {}) } : {}) }, ...(p.log || [])].slice(0, 300);
        return { ...p, done, prog, rate, rev, log, ...(course ? { course } : {}) };
      });
    }
    endSession();
    setSavedToast((leaves.length ? `Registro salvo · ${leaves.length} ${leaves.length === 1 ? "assunto" : "assuntos"} no edital` : "Registro salvo no edital")
      + (aulas.length ? ` · ${aulas.length} ${aulas.length === 1 ? "aula" : "aulas"} do Estratégia` : ""));
    setTimeout(() => setSavedToast(null), 3500);
    if (then === "start") setTimeout(() => setStartOpen(true), 80);
  }
  const guardSetIdx = i => {
    if (sessionRef.current && i !== activeIdx) { appAlert("Finalize a sessão atual antes de trocar de matéria.", { title: "Sessão em andamento" }); return; }
    setActiveIdx(i);
  };
  // ── Modo teste (administrador) ──
  const testSnap = loadLS("sf_testSnap", null);
  const testDeltaSec = testMode && testSnap && testSnap.cycleId === cycle.id
    ? Math.max(0, subjects.reduce((a, x) => a + (x.studiedSec || 0), 0) - (testSnap.studied || []).reduce((a, v) => a + (v || 0), 0)) : 0;
  const testEditalChanged = !!(testMode && testSnap && editalStore.data && (testSnap.edital
    ? (editalStore.data.updatedAt || 0) !== (testSnap.edital.updatedAt || 0)
    : (editalStore.data.log || []).some(l => l.test || (testSnap.at && l.at >= testSnap.at))));
  function revertTest() {
    const snap = loadLS("sf_testSnap", null);
    if (!snap || snap.cycleId !== cycle.id) return;
    const restored = subjects.map((x, i) => ({ ...x, studiedSec: (snap.studied || [])[i] || 0 }));
    if (snap.edital) { const ed0 = snap.edital; editalUpdate(p => ({ ...ed0, plans: p.plans, active: p.active, lang: p.lang })); }   // desfaz o que o teste marcou no edital
    else {
      // teste ligado antes desta versão: desfaz pelo horário (tudo que foi registrado depois que o teste começou)
      const since = snap.at || 0;
      editalUpdate(p => {
        const log = p.log || [];
        const testLogs = since ? log.filter(l => l.at >= since) : log.filter(l => l.test);
        if (!testLogs.length) return p;
        const keys = new Set();
        testLogs.forEach(l => { const d = edObj && edObj.disc.find(x => x.id === l.disc);
          sessTopicIds(l).forEach(tid => { const node = d ? editalFlat(d.topics).find(x => x.node.id === tid)?.node : null;
            (node ? editalLeaves([node]) : []).forEach(id => keys.add(`${l.fam}:${l.disc}:${id}`)); }); });
        const at0 = since || Math.min(...testLogs.map(l => l.at));
        const clean = (obj, isTs) => { const o = { ...(obj || {}) }; Object.keys(o).forEach(k => { const v = o[k]; const ts = typeof v === "object" ? v.at : v; if ((isTs && ts >= at0) || (keys.has(k) && (typeof ts !== "number" || ts >= at0 || ts === 1))) delete o[k]; }); return o; };
        return { ...p, done: clean(p.done, true), prog: clean(p.prog, false), rate: clean(p.rate, true), rev: clean(p.rev, true), log: log.filter(l => !testLogs.includes(l)) };
      });
    }
    // encerra a sessão que estava aberta no teste
    setSession(null); setFinishOpen(null); setTimeUp(false); setOvertime(null); setStartOpen(false);
    setSubjectsLocal(restored);
    onSaveTime(restored);
    setRunning(false);
    startedRef.current = false;
    saveLS("sf_timerRunning", false); saveLS("sf_timerWallStart", null);
    const sj = restored[activeIdx];
    setTimeLeft(sj ? Math.max(0, sj.blockMin * 60 - (sj.studiedSec || 0)) : null);
    bumpStarted(x => x + 1);
  }
  function setTestMode(on) {
    if (running) { appAlert("Pause o cronômetro antes de mudar o modo teste.", { title: "Cronômetro em andamento" }); return; }
    const finish = () => { saveLS("sf_testMode", on); if (!on) saveLS("sf_testSnap", null); setTestModeState(on); };
    if (on) {
      saveLS("sf_testSnap", { cycleId: cycle.id, at: Date.now(), studied: subjects.map(x => x.studiedSec || 0), edital: editalStore.data ? JSON.parse(JSON.stringify(editalStore.data)) : null });
      finish();
      return;
    }
    if (testDeltaSec > 0 || testEditalChanged) {
      appConfirm(`${testDeltaSec > 0 ? `Você registrou ${minutesToHuman(Math.max(1, Math.round(testDeltaSec / 60)))} em modo teste.` : "Você fez alterações no edital em modo teste."}\n\nReverter devolve o ciclo e o edital ao ponto em que o teste começou. Manter deixa esse progresso (sem contar no ranking nem no calendário).`,
        { title: "Sair do modo teste", confirmText: "Reverter teste", cancelText: "Manter progresso", danger: true })
        .then(ok => { if (ok === null) return; if (ok) revertTest(); finish(); });   // fechar pelo fundo/Esc não sai do modo teste
    } else finish();
  }
  // Controles na tela de bloqueio
  useEffect(() => {
    if (!lockEnabled()) return;
    if (!running && !startedRef.current) { lockStop(); return; }
    const known = CONTEST_LIST.find(c => c.id === cycle.contest);
    lockSet({ running, title: subject.name, artist: `G17 · ${known?.label || String(cycle.contest || "Estudo").toUpperCase()}`, duration: blockSec, position: blockSec - tl });
  }, [running, activeIdx]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => () => lockStop(), []);

  // Publica o estado para o bloco flutuante
  const toggleRef = React.useRef(toggleTimer);
  toggleRef.current = toggleTimer;
  const startedRef = React.useRef(false);
  const [, bumpStarted] = useState(0);
  if (running) startedRef.current = true;
  useEffect(() => {
    publishTimer(
      { running: running || !!(overtime && overtime.wall), tl: overtime ? otShown : tl, over: !!overtime, subjectName: subject.name, color: subject.color, contest: cycle.contest, started: running || startedRef.current || !!overtime },
      () => toggleRef.current(),
      () => { startedRef.current = false; bumpStarted(x => x + 1); }
    );
  });
  useEffect(() => () => publishTimer(null, null, null), []);
  // Bloco concluído ou matéria trocada: não há mais cronômetro em andamento
  useEffect(() => {
    if ((tl === 0 || (!running && timeLeft === null)) && startedRef.current && !otRef.current && !sessionRef.current) { startedRef.current = false; bumpStarted(x => x + 1); }
  }, [tl, running, timeLeft]);

  return (
    <div>
      {startOpen && (
        <SessionStartModal kind={splitEnabled && splitPhase === "revisao" && tl > 0 && reviewSec > 0 ? "revisao" : "estudo"}
          subjectName={subject.name} d={edDisc} fam={edFam} data={edData} estr={isAdmin ? estrFor(subject.name) : null}
          onCancel={() => setStartOpen(false)} onStart={beginSession} />
      )}
      {savedToast && ReactDOM.createPortal(
        <div role="status" style={{ position:"fixed", left:"50%", transform:"translateX(-50%)", bottom:"calc(6rem + env(safe-area-inset-bottom))", zIndex:130, background:t.bgCard, border:`1px solid ${t.ac}`, color:t.text, borderRadius:12, padding:"0.7rem 1.1rem", fontSize:"0.86rem", fontWeight:600, boxShadow:"0 12px 30px rgba(0,0,0,0.4)", display:"flex", alignItems:"center", gap:"0.5rem", maxWidth:"calc(100vw - 32px)" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={t.ac} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>{savedToast}
        </div>, document.body
      )}
      {timeUp && session && ReactDOM.createPortal(
        <div style={{ position:"fixed", inset:0, zIndex:125, background:"rgba(0,0,0,0.55)", display:"flex", alignItems:"center", justifyContent:"center", padding:"1rem" }}>
          <div role="alertdialog" aria-labelledby="g17-timeup" style={{ width:"100%", maxWidth:440, background:t.bgCard, border:`1px solid ${t.border}`, borderRadius:16, padding:"1.3rem 1.3rem 1.1rem", boxShadow:"0 24px 60px rgba(0,0,0,0.5)" }}>
            <div style={{ display:"flex", alignItems:"center", gap:"0.6rem", marginBottom:"0.5rem" }}>
              <span style={{ width:34, height:34, borderRadius:"50%", background:t.acDim, color:t.ac, display:"flex", alignItems:"center", justifyContent:"center" }}><NavIcon id="rotina" size={18} /></span>
              <h2 id="g17-timeup" style={{ margin:0, fontSize:"1.15rem", fontWeight:800, color:t.text }}>Tempo esgotado!</h2>
            </div>
            <p style={{ margin:"0 0 1.1rem", fontSize:"0.88rem", color:t.textMid, lineHeight:1.5 }}>
              Sua sessão de {session.kind === "revisao" ? "revisão" : "estudo"} de <strong style={{ color:t.text }}>{subjects[session.idx]?.name || subject.name}</strong> terminou. Finalize-a para registrar o que você estudou, ou continue — o tempo extra também conta.
            </p>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:"0.6rem", flexWrap:"wrap" }}>
              <button onClick={() => setTimeUp(false)} style={{ background:"transparent", border:"none", color:t.text, cursor:"pointer", fontSize:"0.9rem", fontWeight:600, padding:"0.6rem 0.3rem" }}>Continuar estudando</button>
              <button onClick={() => openFinish(session.kind === "revisao" ? "start" : null)}
                style={{ background:t.ac, color: t.mode === "dark" ? "#0a0f0b" : "#fff", border:"none", borderRadius:10, padding:"0.7rem 1.2rem", fontWeight:800, cursor:"pointer", fontSize:"0.9rem" }}>Finalizar sessão</button>
            </div>
          </div>
        </div>,
        document.body
      )}
      {finishOpen && session && (
        <SessionFinishModal session={session} subjectName={subjects[session.idx]?.name || subject.name}
          d={session.disc && edObj ? edObj.disc.find(x => x.id === session.disc) : null} fam={session.fam} data={edData}
          measuredSec={sessMeasured} plannedSec={session.kind === "revisao" ? reviewSec : (splitEnabled ? advanceSec : blockSec)}
          onClose={() => setFinishOpen(null)}
          onSave={saveSession} onDiscard={discardSession} />
      )}
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:"1.2rem",flexWrap:"wrap",gap:"0.8rem"}}>
        <div style={{minWidth:0}}>
          <TacEyebrow color={t.textDim} style={{ marginBottom:"0.4rem", whiteSpace:"nowrap" }}>Ciclo ativo</TacEyebrow>
          <h2 style={{fontSize:"1.6rem",fontWeight:800,margin:0,color:t.text,letterSpacing:"-0.03em"}}>{cycle.name}</h2>
        </div>
        <div style={{display:"flex",gap:"0.5rem",flexWrap:"wrap"}}>
          {isAdmin && (
            <button onClick={() => setTestMode(!testMode)} aria-pressed={testMode} title="Só para o administrador: o ciclo não conta no ranking nem no calendário"
              style={{background: testMode ? "rgba(251,191,36,0.14)" : "transparent", border:`1px solid ${testMode ? "#fbbf24" : t.border}`, borderRadius:8, padding:"0.5rem 1rem", color: testMode ? "#fbbf24" : t.textDim, fontSize:"0.78rem", fontWeight: testMode ? 700 : 400, cursor:"pointer", display:"inline-flex", alignItems:"center", gap:"0.4rem"}}>
              <NavIcon id="ferramenta" size={14} />{testMode ? "Modo teste: ligado" : "Modo teste"}
            </button>
          )}
          <button onClick={running ? null : onEdit} disabled={running} style={{background:"transparent",border:`1px solid ${t.border}`,borderRadius:8,padding:"0.5rem 1rem",color:running?"#60708050":t.textDim,fontSize:"0.78rem",cursor:running?"not-allowed":"pointer",opacity:running?0.5:1}}><IconLabel icon="editar">Editar</IconLabel></button>
          <button onClick={running ? null : onDelete} disabled={running} style={{background:"transparent",border:`1px solid #ef444460`,borderRadius:8,padding:"0.5rem 1rem",color:running?"#ef444450":"#ef4444",fontSize:"0.78rem",cursor:running?"not-allowed":"pointer",opacity:running?0.5:1}}><IconLabel icon="lixeira">Excluir</IconLabel></button>
          <button onClick={running ? null : onNew} disabled={running} style={{background:running?t.border:t.ac,color:running?t.textFaint:t.mode==="dark"?"#0a0f0b":"#fff",border:"none",borderRadius:8,padding:"0.5rem 1rem",fontSize:"0.78rem",fontWeight:700,cursor:running?"not-allowed":"pointer",opacity:running?0.5:1}}><IconLabel icon="adicionar" size={15} gap="0.35rem">Novo ciclo</IconLabel></button>
        </div>
      </div>

      {isAdmin && testMode && (
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:"0.8rem",flexWrap:"wrap",marginBottom:"1rem",padding:"0.7rem 1rem",borderRadius:12,background:"rgba(251,191,36,0.1)",border:"1px solid rgba(251,191,36,0.4)"}}>
          <div style={{minWidth:0}}>
            <div style={{fontSize:"0.78rem",fontWeight:800,color:"#fbbf24",letterSpacing:"0.04em",textTransform:"uppercase"}}>Modo teste ativo</div>
            <div style={{fontSize:"0.76rem",color:t.textMid,lineHeight:1.4}}>O tempo deste ciclo não conta no ranking nem no calendário. O que for marcado no edital é desfeito ao reverter.{testDeltaSec > 0 ? ` Registrado no teste: ${minutesToHuman(Math.max(1, Math.round(testDeltaSec / 60)))}.` : ""}</div>
          </div>
          <button onClick={() => appConfirm("O ciclo e o edital voltam ao ponto em que o modo teste foi ligado.", { title: "Reverter o que foi feito no teste?", confirmText: "Reverter", danger: true }).then(ok => { if (ok) revertTest(); })}
            disabled={running || (testDeltaSec <= 0 && !testEditalChanged)}
            style={{background:"transparent",border:"1px solid #fbbf2480",borderRadius:8,padding:"0.45rem 0.9rem",color: running || (testDeltaSec <= 0 && !testEditalChanged) ? t.textFaint : "#fbbf24",fontSize:"0.78rem",fontWeight:700,cursor: running || (testDeltaSec <= 0 && !testEditalChanged) ? "not-allowed" : "pointer"}}>
            Reverter teste
          </button>
        </div>
      )}

      {/* Resumo do ciclo + concurso alvo */}
      {(() => {
        const doneCount = subjects.filter(x => (x.studiedSec||0) >= x.blockMin*60).length;
        const nextSub = (subject && (subject.studiedSec||0) < subject.blockMin*60) ? subject : subjects.find(x => (x.studiedSec||0) < x.blockMin*60);
        const pct = Math.round((totalStudied/Math.max(1,totalTarget))*100);
        const hm = sec => minutesToHuman(Math.max(0, Math.round(sec/60)));
        const known = CONTEST_LIST.find(c => c.id === cycle.contest);
        const contestLabel = known?.label || (cycle.contest ? String(cycle.contest).toUpperCase() : "Personalizado");
        const contestSub = cargoLabel || known?.full || (cycle.contest ? "" : "Matérias escolhidas por você");
        const card = { background:t.bgCard, border:`1px solid ${t.border}`, borderRadius:14, position:"relative" };
        const stats = [
          { k:"Horas realizadas", v: hm(totalStudied), sub: pct + "% do ciclo" },
          { k:"Horas restantes",  v: hm(totalTarget - totalStudied), sub: "de " + hm(totalTarget) + " no total" },
          { k:"Sessões concluídas", v: `${doneCount}/${subjects.length}`, sub: subjects.length - doneCount === 1 ? "falta 1" : `faltam ${subjects.length - doneCount}` },
        ];
        return (
          <div style={{ display:"grid", gridTemplateColumns: isMobile ? "1fr" : "minmax(0,1.7fr) minmax(0,1fr)", gap: isMobile ? "0.8rem" : "1rem", marginBottom:"1.4rem" }}>
            <div style={{ ...card, padding: isMobile ? "1rem" : "1.1rem 1.2rem", order: isMobile ? 2 : 1 }}>
              <TacEyebrow color={t.textDim} style={{ marginBottom:"0.8rem" }}>Resumo do ciclo</TacEyebrow>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(3, minmax(0,1fr))", gap: isMobile ? "0.5rem" : "0.7rem", marginBottom:"0.9rem" }}>
                {stats.map(st => (
                  <div key={st.k} style={{ background:t.bgInner, border:`1px solid ${t.borderIn}`, borderRadius:10, padding: isMobile ? "0.6rem 0.65rem" : "0.75rem 0.9rem", minWidth:0 }}>
                    <div style={{ fontSize: isMobile ? "0.6rem" : "0.66rem", fontWeight:700, color:t.textDim, textTransform:"uppercase", letterSpacing:"0.06em", lineHeight:1.25, marginBottom:"0.3rem" }}>{st.k}</div>
                    <div className="tac-num" style={{ fontSize: isMobile ? "1.2rem" : "1.55rem", fontWeight:800, color:t.text, letterSpacing:"-0.02em", lineHeight:1.1, whiteSpace:"nowrap" }}>{st.v}</div>
                    <div style={{ fontSize:"0.68rem", color:t.textFaint, marginTop:"0.2rem", lineHeight:1.3 }}>{st.sub}</div>
                  </div>
                ))}
              </div>
              <TickBar value={totalStudied} max={totalTarget} segments={isMobile ? 20 : 32} color={t.ac} height={7} />
              <div style={{ display:"flex", justifyContent:"space-between", marginTop:"0.45rem", fontSize:"0.74rem", color:t.textDim, gap:"0.5rem" }}>
                <span><strong className="tac-num" style={{ color:t.ac }}>{pct}%</strong> concluído</span>
                <span>{!nextSub ? "Ciclo completo!" : <>{nextSub === subject ? "Agora" : "Próxima"}: <strong style={{ color:t.textMid }}>{nextSub.name}</strong></>}</span>
              </div>
            </div>

            <div style={{ ...card, padding: isMobile ? "0.9rem 1rem" : "1.1rem 1.2rem", order: isMobile ? 1 : 2, display:"flex", alignItems:"center", gap: isMobile ? "0.9rem" : "1.1rem", overflow:"hidden" }}>
              <div style={{ position:"absolute", right:-40, top:"50%", transform:"translateY(-50%)", width:220, height:220, borderRadius:"50%", background:`radial-gradient(circle, ${(known?.color||t.ac)}22 0%, transparent 70%)`, pointerEvents:"none" }} />
              <ContestEmblem id={cycle.contest} size={isMobile ? 68 : 96} style={{ filter: t.mode === "dark" ? "drop-shadow(0 6px 16px rgba(0,0,0,0.45))" : "drop-shadow(0 6px 14px rgba(20,24,40,0.16))", position:"relative" }} />
              <div style={{ minWidth:0, position:"relative" }}>
                <TacEyebrow color={t.textDim} style={{ marginBottom:"0.3rem" }}>Concurso alvo</TacEyebrow>
                <div style={{ fontSize: isMobile ? "1.4rem" : "1.75rem", fontWeight:900, color:t.text, letterSpacing:"-0.02em", lineHeight:1.05 }}>{contestLabel}</div>
                {contestSub && <div style={{ fontSize:"0.8rem", color:t.textMid, marginTop:"0.25rem", lineHeight:1.35 }}>{contestSub}</div>}
                {known && cycle.contest !== "outros" && <div style={{ fontSize:"0.62rem", color:t.textFaint, marginTop:"0.45rem", lineHeight:1.35 }}>O G17 não tem vínculo com a instituição.</div>}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Main layout: ring left, info right */}
      <div style={{display:"grid",gridTemplateColumns:isMobile?"minmax(0,1fr)":"390px minmax(0,1fr)",gap:"1.5rem",alignItems:"start",marginBottom:"1.5rem"}}>

        {/* Ring */}
        <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
          <StudyRing3D
            subjects={subjects}
            activeIdx={activeIdx}
            setActiveIdx={guardSetIdx}
            running={running}
            totalStudiedNow={totalStudiedNow}
            modeInfo={session && session.mode ? ALL_MODES.find(m => m.id === session.mode) : null}
            overtimeSec={otShown}
            sessionKind={session ? session.kind : null}
            completed={tl === 0 && !overtime && !(splitEnabled && splitPhase === "revisao" && advanceSec > 0)}
            topicLabel={(() => {
              const ids = sessTopicIds(session);
              if (!ids.length || !session.disc || !edObj) return null;
              const sd = edObj.disc.find(x => x.id === session.disc);
              const nodes = sd ? ids.map(id => editalFlat(sd.topics).find(x => x.node.id === id)?.node).filter(Boolean) : [];
              const node = nodes[0];
              return node ? `${node.n ? node.n + ". " : ""}${node.t}${nodes.length > 1 ? ` (+${nodes.length - 1})` : ""}` : null;
            })()}
            phase={phase}
            subject={subject}
            timeLeft={timeLeft}
            remaining={remaining}
            t={t}
            size={ringSize}
          />

          {/* Play/pause */}
          <div style={{display:"flex",gap:"0.5rem",marginTop:"0.5rem",width:"100%",justifyContent:"center"}}>
            {!(tl === 0 && !overtime && !session && !(splitEnabled && splitPhase === "revisao" && advanceSec > 0)) && <button onClick={() => toggleTimer(true)}
              style={{background:(running || (overtime && overtime.wall))?"#ef4444":overtime?subject.color:tl===0?"#4ade80":subject.color,color:"#fff",border:"none",borderRadius:12,padding:"0.75rem 2rem",fontWeight:700,fontSize:"1rem",cursor:tl===0&&!overtime?"default":"pointer",flex:1,maxWidth:200}}>
              {overtime ? (overtime.wall
                ? <><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{verticalAlign:"-2px",marginRight:8}}><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>Pausar</>
                : <><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{verticalAlign:"-2px",marginRight:8}}><path d="M8 5v14l11-7z" /></svg>Continuar</>)
              : tl===0 && splitEnabled && splitPhase==="revisao" && advanceSec>0 ? <><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{verticalAlign:"-2px",marginRight:8}}><path d="M8 5v14l11-7z" /></svg>Iniciar Avanço</> : tl===0?<><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{verticalAlign:"-2px",marginRight:8}}><path d="M5 12l5 5 9-10" /></svg>Concluído</>:running?<><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{verticalAlign:"-2px",marginRight:8}}><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>Pausar</>:<><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{verticalAlign:"-2px",marginRight:8}}><path d="M8 5v14l11-7z" /></svg>{(blockSec - tl) > 0 ? "Continuar" : "Iniciar"}</>}
            </button>}
            {session && (
              <button onClick={() => openFinish(null)}
                style={{background:t.acDim,color:t.ac,border:`1px solid ${t.ac}`,borderRadius:12,padding:"0.75rem 1rem",fontWeight:700,fontSize:"0.95rem",cursor:"pointer",flex:1,maxWidth:200,display:"inline-flex",alignItems:"center",justifyContent:"center",gap:"0.5rem"}}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="5" y="5" width="14" height="14" rx="2.5" /></svg>{isMobile ? "Finalizar" : "Finalizar sessão"}
              </button>
            )}
          </div>
        </div>

        {/* Right panel */}
        <div style={{display:"flex",flexDirection:"column",gap:"0.8rem"}}>
          <div>
            <p style={{color:t.textDim,fontSize:"0.78rem",margin:"0 0 0.15rem",textTransform:"uppercase",letterSpacing:"0.1em"}}>{cycle.name} · {cycle.contest?.toUpperCase()}</p>
            <h2 style={{fontSize:"2rem",fontWeight:900,color:subject.color,margin:"0 0 0.2rem",lineHeight:1.1}}>{subject.name}</h2>
            <p style={{color:t.textFaint,fontSize:"0.78rem",margin:0}}>Peso {subject.weight} · {"★".repeat(subject.stars)}{"☆".repeat(5-subject.stars)} · meta: {minutesToHuman(subject.blockMin)}/semana</p>
          </div>

          {/* G17 tip */}
          <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:10,padding:"0.9rem"}}>
            <p style={{color:t.textDim,fontSize:"0.68rem",textTransform:"uppercase",letterSpacing:"0.1em",margin:"0 0 0.3rem",fontWeight:700}}>Sugestão do G17</p>
            <p style={{color:t.textMid,fontSize:"0.82rem",margin:0,lineHeight:1.5}}>Divida sua sessão: <strong style={{color:"#60a5fa"}}>revise</strong> conteúdo anterior primeiro, depois avance em <strong style={{color:subject.color}}>conteúdo novo</strong>. Padrão: 1/3 revisão e 2/3 avanço.</p>
          </div>

          {/* Split control */}
          <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:10,padding:"0.9rem",opacity:running?0.6:1,pointerEvents:running?"none":"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:splitEnabled?"0.8rem":0}}>
              <p style={{margin:0,fontSize:"0.85rem",fontWeight:600,color:t.text}}>Divisão do tempo de estudo</p>
              <div onClick={running ? null : toggleSplit}
                style={{width:20,height:20,borderRadius:4,background:splitEnabled?t.ac:t.bgInner,border:`1px solid ${splitEnabled?t.ac:t.border}`,display:"flex",alignItems:"center",justifyContent:"center",cursor:running?"not-allowed":"pointer",color:"#fff",fontSize:"0.75rem",fontWeight:900,flexShrink:0}}>
                {splitEnabled && <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>}
              </div>
            </div>
            {splitEnabled&&(
              <>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"0.4rem",gap:"0.5rem"}}>
                  {editingSplit === "revisao" ? (
                    <span style={{display:"flex",alignItems:"center",gap:4,fontSize:"0.78rem",fontWeight:700,color:"#60a5fa"}}>
                      <NavIcon id="seta_rev" size={14} />
                      <input
                        type="number" min={0} max={Math.floor(splitBase / 60)} step={1} autoFocus
                        value={splitInputVal}
                        onChange={e=>setSplitInputVal(e.target.value)}
                        onBlur={commitSplitInput}
                        onKeyDown={e=>{ if(e.key==="Enter") commitSplitInput(); if(e.key==="Escape"){ setEditingSplit(null); setSplitInputVal(""); } }}
                        style={{width:48,background:t.bgInner,border:"1px solid #60a5fa",borderRadius:6,color:t.text,fontSize:"0.78rem",fontWeight:700,padding:"0.1rem 0.3rem",textAlign:"center"}}
                      /> min revisão
                    </span>
                  ) : (
                    <span
                      onClick={()=>{ if(running) return; setEditingSplit("revisao"); setSplitInputVal(String(Math.round(reviewSec/60))); }}
                      style={{fontSize:"0.78rem",fontWeight:700,color:"#60a5fa",cursor:running?"default":"pointer",display:"inline-flex",alignItems:"center",gap:"0.3rem"}}
                      title="Clique para digitar o tempo de revisão"><NavIcon id="seta_rev" size={14} /> {formatTimer(reviewSec)} revisão <NavIcon id="editar" size={11} /></span>
                  )}

                  {editingSplit === "avanco" ? (
                    <span style={{display:"flex",alignItems:"center",gap:4,fontSize:"0.78rem",fontWeight:700,color:subject.color}}>
                      <input
                        type="number" min={0} max={Math.floor(splitBase / 60)} step={1} autoFocus
                        value={splitInputVal}
                        onChange={e=>setSplitInputVal(e.target.value)}
                        onBlur={commitSplitInput}
                        onKeyDown={e=>{ if(e.key==="Enter") commitSplitInput(); if(e.key==="Escape"){ setEditingSplit(null); setSplitInputVal(""); } }}
                        style={{width:48,background:t.bgInner,border:`1px solid ${subject.color}`,borderRadius:6,color:t.text,fontSize:"0.78rem",fontWeight:700,padding:"0.1rem 0.3rem",textAlign:"center"}}
                      /> min avanço
                    </span>
                  ) : (
                    <span
                      onClick={()=>{ if(running) return; setEditingSplit("avanco"); setSplitInputVal(String(Math.round(advanceSec/60))); }}
                      style={{fontSize:"0.78rem",fontWeight:700,color:subject.color,cursor:running?"default":"pointer",display:"inline-flex",alignItems:"center",gap:"0.3rem"}}
                      title="Clique para digitar o tempo de avanço"><NavIcon id="editar" size={11} /> {formatTimer(advanceSec)} avanço <NavIcon id="seta_av" size={14} /></span>
                  )}
                </div>
                <div style={{position:"relative",marginBottom:"0.4rem"}}>
                  <input type="range" min={0} max={1} step={0.025} value={splitRatio}
                    onChange={e=>setSplitRatio(Number(e.target.value))}
                    disabled={running}
                    style={{width:"100%",accentColor:"#60a5fa",cursor:running?"not-allowed":"pointer"}}/>
                  <div style={{display:"flex",height:6,borderRadius:99,overflow:"hidden",marginTop:4}}>
                    <div style={{flex:splitRatio,background:"#60a5fa",transition:"flex 0.1s"}}/>
                    <div style={{flex:1-splitRatio,background:subject.color,transition:"flex 0.1s"}}/>
                  </div>
                </div>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:"0.7rem",color:"#60a5fa",display:"flex",alignItems:"center",gap:4}}><span style={{width:8,height:8,borderRadius:2,background:"#60a5fa",display:"inline-block"}}/>Revisão</span>
                  <span style={{fontSize:"0.7rem",color:subject.color,display:"flex",alignItems:"center",gap:4}}>Conteúdo novo<span style={{width:8,height:8,borderRadius:2,background:subject.color,display:"inline-block"}}/></span>
                </div>
              </>
            )}
          </div>

        </div>
      </div>

      {/* ── LISTA DE BLOCOS — layout de referência ── */}
      {(() => {
        // Estados extras no topo do componente precisam existir — defini-los aqui inline via ref
        return null;
      })()}
      <BlockList
        subjects={subjects}
        activeIdx={activeIdx}
        running={running}
        setActiveIdx={guardSetIdx}
        t={t}
        onInsertTime={(idx, sec) => {
          const s = subjects[idx];
          const maxSec = s.blockMin * 60;
          const already = s.studiedSec || 0;
          const room = Math.max(0, maxSec - already);
          const toAdd = Math.min(sec, room);
          if (toAdd > 0) { commitTime(idx, toAdd, false, true); onAddStudiedSec && onAddStudiedSec(toAdd); }
        }}
        onMarkDone={(idx) => {
          const s = subjects[idx];
          const maxSec = s.blockMin * 60;
          const already = s.studiedSec || 0;
          const toAdd = Math.max(0, maxSec - already);
          if (toAdd > 0) { commitTime(idx, toAdd, false, true); onAddStudiedSec && onAddStudiedSec(toAdd); }
        }}
        onReset={(idx) => {
          setSubjectsLocal(prev => {
            const updated = prev.map((s,i) => i===idx ? {...s, studiedSec:0} : s);
            onSaveTime(updated);
            return updated;
          });
          setTimeLeft(subjects[idx].blockMin * 60);
        }}
      />

      {/* ── RESUMO SEMANAL — agrupado, somente leitura ── */}
      {(() => {
        const grouped = {};
        subjects.forEach(s => {
          if (!grouped[s.name]) grouped[s.name] = { name:s.name, color:s.color, totalMin:0, studiedSec:0 };
          grouped[s.name].totalMin   += s.blockMin;
          grouped[s.name].studiedSec += (s.studiedSec||0);
        });
        const rows = Object.values(grouped);
        return (
          <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:12,overflow:"hidden",marginTop:"1.5rem",position:"relative"}}>
            <TacCorners color={t.ac} size={10} thickness={1.5} inset={-1} opacity={0.3} />
            <div style={{padding:"0.8rem 1.2rem",borderBottom:`1px solid ${t.borderIn}`,background:t.bgInner}}>
              <TacEyebrow color={t.textDim}>Resumo</TacEyebrow>
            </div>
            {/* Total row */}
            <div style={{display:"grid",gridTemplateColumns:"1fr auto auto",padding:"0.8rem 1.2rem",borderBottom:`1px solid ${t.border}`,background:t.bgInner+"80",gap:"1rem",alignItems:"center"}}>
              <span style={{fontWeight:700,color:t.text,fontSize:"0.87rem"}}>Total</span>
              <span style={{fontWeight:600,color:t.textMid,fontSize:"0.87rem",fontFamily:"monospace",minWidth:80,textAlign:"right"}}>{formatTimer(totalTarget)}</span>
              <span style={{color:t.ac,fontSize:"0.87rem",fontWeight:600,fontFamily:"monospace",minWidth:90,textAlign:"right",display:"flex",alignItems:"center",gap:"0.3rem"}}>
                <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                {formatTimer(totalStudied)}
              </span>
            </div>
            {rows.map((r,i) => {
              const studied = r.studiedSec;
              const isDone = studied >= r.totalMin*60;
              return (
                <div key={r.name} style={{display:"grid",gridTemplateColumns:"1fr auto auto",padding:"0.7rem 1.2rem",borderBottom:i<rows.length-1?`1px solid ${t.borderIn}`:"none",alignItems:"center",gap:"1rem"}}>
                  <span style={{fontSize:"0.82rem",color:t.textMid,fontWeight:500}}>{r.name}</span>
                  <span style={{fontSize:"0.82rem",color:t.textMid,fontFamily:"monospace",minWidth:80,textAlign:"right"}}>{formatTimer(r.totalMin*60)}</span>
                  <span style={{fontSize:"0.82rem",fontFamily:"monospace",minWidth:isMobile?0:90,textAlign:"right",display:"flex",alignItems:"center",gap:"0.3rem",color:isDone?"#4ade80":studied>0?t.ac:t.textFaint}}>
                    <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                    {formatTimer(studied)}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })()}
    </div>
  );
}

// ── BLOCK LIST COMPONENT ─────────────────────────────────────────────────────
function BlockList({ subjects, activeIdx, running, setActiveIdx, t, onInsertTime, onMarkDone, onReset }) {
  const isMobile = useIsMobile();
  const [menu, setMenu] = React.useState(null); // {idx, rect}
  const [insertModal, setInsertModal] = React.useState(null); // {idx}
  const [insertH, setInsertH] = React.useState("");
  const [insertM, setInsertM] = React.useState("");
  const [insertErr, setInsertErr] = React.useState("");
  const [justDoneIdx, setJustDoneIdx] = React.useState(null); // feedback de "recuo" ao concluir um bloco
  const prevDoneRef = React.useRef({});
  const [rv, gv, bv] = hexToRgb(t.ac);

  // Dispara um "recuo" sutil sempre que um bloco transiciona para concluído
  // (seja pelo timer chegando a zero, seja marcado manualmente no menu).
  React.useEffect(() => {
    subjects.forEach((s, idx) => {
      const isDoneNow = (s.studiedSec || 0) >= s.blockMin * 60;
      const wasDone = prevDoneRef.current[idx];
      if (isDoneNow && wasDone === false) {
        setJustDoneIdx(idx);
        setTimeout(() => setJustDoneIdx(i => i === idx ? null : i), 450);
      }
      prevDoneRef.current[idx] = isDoneNow;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjects]);

  function openMenu(idx, e) {
    e.stopPropagation();
    setMenu(menu?.idx === idx ? null : { idx, rect: e.currentTarget.getBoundingClientRect() });
  }

  function submitInsert() {
    const h = parseInt(insertH)||0, m = parseInt(insertM)||0;
    const sec = h*3600 + m*60;
    if (sec <= 0) { setInsertErr("Informe um tempo válido."); return; }
    const s = subjects[insertModal.idx];
    const max = s.blockMin*60, already = s.studiedSec||0;
    if (sec > max - already) { setInsertErr("O tempo que você está tentando subtrair é maior do que o tempo disponível!"); return; }
    onInsertTime(insertModal.idx, sec);
    setInsertModal(null); setInsertH(""); setInsertM(""); setInsertErr("");
  }

  const cols = isMobile ? "minmax(0,1fr) 4.4rem 4.4rem 2rem" : "1fr 7rem 9rem 2.2rem 2.2rem";
  const [showAll, setShowAll] = React.useState(false);
  const N = subjects.length, WIN = 8;
  const collapsible = N > WIN + 2;
  const winStart = Math.max(0, Math.min(N - WIN, activeIdx - 2));
  const visible = idx => !collapsible || showAll || (idx >= winStart && idx < winStart + WIN);
  const doneCount = subjects.filter(s => (s.studiedSec||0) >= s.blockMin*60).length;

  return (
    <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:12,overflow:"hidden",marginTop:"1.5rem"}}>
      {/* Título */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:"0.6rem",padding:isMobile?"0.8rem 0.9rem":"0.9rem 1.2rem",borderBottom:`1px solid ${t.borderIn}`}}>
        <div style={{display:"flex",alignItems:"center",gap:"0.5rem"}}>
          <span style={{fontWeight:800,fontSize:"0.95rem",color:t.text}}>Sessões do ciclo</span>
          <span className="tac-num" style={{fontSize:"0.72rem",fontWeight:700,color:t.textMid,background:t.bgInner,border:`1px solid ${t.borderIn}`,borderRadius:6,padding:"0.05rem 0.45rem"}}>{N}</span>
        </div>
        <span className="tac-num" style={{fontSize:"0.74rem",color:t.textDim}}>{doneCount} de {N} concluídas</span>
      </div>
      {/* Header */}
      <div style={{display:"grid",gridTemplateColumns:cols,padding:isMobile?"0.6rem 0.7rem":"0.6rem 1.2rem",borderBottom:`1px solid ${t.border}`,background:t.bgInner}}>
        <span style={{fontSize:"0.72rem",fontWeight:700,color:t.textFaint,textTransform:"uppercase",letterSpacing:"0.08em"}}>Matéria</span>
        <span style={{fontSize:"0.72rem",fontWeight:700,color:t.textFaint,textTransform:"uppercase",letterSpacing:isMobile?"0.02em":"0.08em",textAlign:"center"}}>Sessão</span>
        <span style={{fontSize:"0.72rem",fontWeight:700,color:t.textFaint,textTransform:"uppercase",letterSpacing:isMobile?"0.02em":"0.08em",textAlign:"center"}}>{isMobile?"Restante":"Tempo restante"}</span>
        {!isMobile && <span/>}
        <span/>
      </div>

      {/* Rows */}
      {subjects.map((s, idx) => {
        if (!visible(idx)) return null;
        const isDone = (s.studiedSec||0) >= s.blockMin*60;
        const isActive = idx === activeIdx;
        const rem = Math.max(0, s.blockMin*60 - (s.studiedSec||0));
        const canPlay = !running || isActive;

        return (
          <div key={idx} onClick={() => { if(canPlay) setActiveIdx(idx); }}
            className={justDoneIdx===idx ? "tac-recoil" : undefined}
            style={{
              display:"grid", gridTemplateColumns:cols,
              padding:isMobile?"0.35rem 0.7rem":"0 1.2rem",
              minHeight:isMobile?52:56,
              alignItems:"center",
              background: isDone ? s.color+"28" : isActive ? s.color+"12" : "transparent",
              borderLeft: isDone ? `4px solid ${s.color}` : isActive ? `4px solid ${s.color}90` : "4px solid transparent",
              borderBottom:`1px solid ${t.borderIn}`,
              cursor: canPlay ? "pointer" : "default",
              transition:"background 0.15s",
            }}
            onMouseEnter={e=>{ if(!isDone&&!isActive&&canPlay) e.currentTarget.style.background=`rgba(${rv},${gv},${bv},0.05)`; }}
            onMouseLeave={e=>{ if(!isDone&&!isActive) e.currentTarget.style.background="transparent"; }}
          >
            {/* Matéria */}
            <span style={{display:"flex",alignItems:"center",gap:isMobile?"0.5rem":"0.7rem",minWidth:0,paddingRight:"0.5rem"}}>
              <span className="tac-num" style={{width:isMobile?22:24,height:isMobile?22:24,borderRadius:"50%",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"0.68rem",fontWeight:800,
                background: isDone ? "rgba(255,255,255,0.22)" : isActive ? s.color : t.bgInner,
                color: isDone ? "#fff" : isActive ? "#fff" : t.textDim,
                border: isDone||isActive ? "none" : `1px solid ${t.borderIn}`}}>{isDone ? "✓" : idx+1}</span>
              <span style={{fontSize:"0.88rem",fontWeight: isDone||isActive ? 700 : 500, color: isDone ? "#fff" : isActive ? t.text : t.textMid, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:isMobile?"normal":"nowrap", lineHeight:isMobile?1.25:undefined, overflowWrap:"anywhere", minWidth:0}}>
                {s.name}
              </span>
            </span>

            {/* Sessão */}
            <span style={{fontSize:isMobile?"0.78rem":"0.85rem",color: isDone?"rgba(255,255,255,0.85)":t.textMid,fontFamily:"monospace",textAlign:"center"}}>
              {(() => {
                const extra = isDone ? Math.floor(Math.max(0, (s.studiedSec||0) - s.blockMin*60) / 60) : 0;
                return extra > 0
                  ? <span style={{display:"inline-flex",alignItems:"center",gap:6,justifyContent:"center",flexWrap:"wrap"}}>
                      <span style={{color:"#fff",fontWeight:800}}>{formatTimer(Math.max(s.blockMin*60, s.studiedSec||0))}</span>
                      <span style={{fontSize:"0.66rem",fontWeight:800,color:"#fbbf24",background:"rgba(251,191,36,0.16)",borderRadius:20,padding:"1px 7px",fontFamily:"inherit"}}>+{extra}min</span>
                    </span>
                  : formatTimer(isDone ? Math.max(s.blockMin*60, s.studiedSec||0) : s.blockMin*60);
              })()}
            </span>

            {/* Tempo restante */}
            <div style={{display:"flex",alignItems:"center",gap:"0.4rem",justifyContent:"center"}}>
              {!isMobile && <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke={isDone?"rgba(255,255,255,0.7)":t.textFaint} strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>}
              <span style={{fontSize:isMobile?"0.78rem":"0.85rem",color: isDone?"rgba(255,255,255,0.85)":t.textMid,fontFamily:"monospace"}}>
                {formatTimer(rem)}
              </span>
            </div>

            {/* Play */}
            {!isMobile && <button
              onClick={e=>{ e.stopPropagation(); if(canPlay) setActiveIdx(idx); }}
              disabled={isDone || !canPlay}
              style={{background:"transparent",border:"none",color: isDone?"transparent": canPlay?t.textDim:"#ffffff30",cursor: isDone||!canPlay?"default":"pointer",padding:"0.3rem",display:"flex",alignItems:"center",justifyContent:"center",borderRadius:6,transition:"color 0.15s"}}
              onMouseEnter={e=>{ if(!isDone&&canPlay) e.currentTarget.style.color=t.ac; }}
              onMouseLeave={e=>{ e.currentTarget.style.color= isDone?"transparent":canPlay?t.textDim:"#ffffff30"; }}
            >
              {!isDone && <svg width={14} height={14} viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>}
            </button>}

            {/* Menu ⋯ */}
            <div style={{position:"relative"}}>
              <button
                onClick={e=>openMenu(idx,e)}
                style={{background:menu?.idx===idx?`rgba(${rv},${gv},${bv},0.15)`:"transparent",border: menu?.idx===idx?`1px solid rgba(${rv},${gv},${bv},0.35)`:"1px solid transparent",color: isDone?"rgba(255,255,255,0.7)":t.textDim,cursor:"pointer",padding:"0.3rem 0.35rem",display:"flex",alignItems:"center",justifyContent:"center",borderRadius:6,transition:"all 0.15s",fontSize:"1rem"}}
                onMouseEnter={e=>{ e.currentTarget.style.background=`rgba(${rv},${gv},${bv},0.1)`; e.currentTarget.style.borderColor=`rgba(${rv},${gv},${bv},0.25)`; }}
                onMouseLeave={e=>{ if(menu?.idx!==idx){e.currentTarget.style.background="transparent";e.currentTarget.style.borderColor="transparent";} }}
              >⋮</button>
            </div>
          </div>
        );
      })}

      {collapsible && (
        <button onClick={() => setShowAll(v => !v)}
          style={{width:"100%",background:"transparent",border:"none",padding:"0.8rem",color:t.textDim,fontSize:"0.8rem",fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:"0.4rem",fontFamily:"inherit"}}>
          {showAll ? "Mostrar menos" : `Ver todas as ${N} sessões`}
          <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{transform:showAll?"rotate(180deg)":"none",transition:"transform 0.15s"}}><polyline points="6 9 12 15 18 9"/></svg>
        </button>
      )}

      {/* Dropdown menu */}
      {menu && ReactDOM.createPortal(
        <>
          <div style={{position:"fixed",inset:0,zIndex:9980}} onClick={()=>setMenu(null)}/>
          <div style={{
            position:"fixed",
            top: menu.rect.bottom + 6,
            right: window.innerWidth - menu.rect.right,
            zIndex:9981,
            background: t.bgCard,
            border:`1px solid rgba(${rv},${gv},${bv},0.18)`,
            borderRadius:10, overflow:"hidden",
            boxShadow:"0 12px 40px rgba(0,0,0,0.5)",
            minWidth:200,
          }}>
            {[
              { icon: <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>, label:"Inserir tempo percorrido", action:()=>{ setInsertModal({idx:menu.idx}); setInsertH(""); setInsertM(""); setInsertErr(""); setMenu(null); } },
              { icon: <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>, label:"Marcar como concluída", action:()=>{
                  const idx = menu.idx; setMenu(null);
                  appConfirm("Tempos registrados manualmente não contam para o ranking.", { title:"Marcar como concluída?", confirmText:"Marcar", icon:"checkcirc" })
                    .then(ok => { if (ok) onMarkDone(idx); });
                } },
              { icon: <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.72"/></svg>, label:"Reiniciar tempo", action:()=>{ onReset(menu.idx); setMenu(null); } },
            ].map((item, i, arr) => (
              <button key={i} onClick={item.action}
                style={{width:"100%",display:"flex",alignItems:"center",gap:"0.65rem",padding:"0.7rem 1rem",background:"transparent",border:"none",borderBottom:i<arr.length-1?`1px solid rgba(${rv},${gv},${bv},0.07)`:"none",color:t.textMid,fontSize:"0.83rem",fontWeight:500,cursor:"pointer",textAlign:"left",transition:"background 0.12s"}}
                onMouseEnter={e=>e.currentTarget.style.background=`rgba(${rv},${gv},${bv},0.08)`}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <span style={{color:t.ac,flexShrink:0}}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </div>
        </>,
        document.body
      )}

      {/* Modal: Inserir tempo percorrido */}
      {insertModal && ReactDOM.createPortal(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",backdropFilter:"blur(8px)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}
          onClick={()=>setInsertModal(null)}>
          <div onClick={e=>e.stopPropagation()} style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:14,padding:"1.8rem",width:"100%",maxWidth:340,boxShadow:"0 24px 64px rgba(0,0,0,0.6)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1.4rem"}}>
              <span style={{fontWeight:800,fontSize:"0.95rem",color:t.text}}>Inserir tempo percorrido</span>
              <button onClick={()=>setInsertModal(null)} style={{background:"transparent",border:"none",color:t.textFaint,cursor:"pointer",fontSize:"1.1rem",padding:0}}>✕</button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr auto 1fr",gap:"0.5rem",alignItems:"center",marginBottom:"0.8rem"}}>
              <div>
                <label style={{display:"block",fontSize:"0.7rem",color:t.textDim,fontWeight:600,marginBottom:"0.3rem",textAlign:"center"}}>Horas</label>
                <input type="number" min={0} max={23} value={insertH} onChange={e=>{setInsertH(e.target.value);setInsertErr("");}}
                  style={{width:"100%",background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:8,padding:"0.7rem",color:t.text,fontSize:"1.1rem",fontWeight:700,outline:"none",textAlign:"center"}} />
              </div>
              <span style={{color:t.textDim,fontWeight:700,fontSize:"1.2rem",textAlign:"center",paddingTop:"1.2rem"}}>:</span>
              <div>
                <label style={{display:"block",fontSize:"0.7rem",color:t.textDim,fontWeight:600,marginBottom:"0.3rem",textAlign:"center"}}>Minutos</label>
                <input type="number" min={0} max={59} value={insertM} onChange={e=>{setInsertM(e.target.value);setInsertErr("");}}
                  onKeyDown={e=>e.key==="Enter"&&submitInsert()}
                  style={{width:"100%",background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:8,padding:"0.7rem",color:t.text,fontSize:"1.1rem",fontWeight:700,outline:"none",textAlign:"center"}} />
              </div>
            </div>
            {insertErr && <p style={{margin:"0 0 0.6rem",fontSize:"0.78rem",color:"#f87171",lineHeight:1.4}}>{insertErr}</p>}
            <div style={{background:"rgba(251,191,36,0.1)",border:"1px solid rgba(251,191,36,0.3)",borderRadius:8,padding:"0.6rem 0.8rem",marginBottom:"0.8rem"}}>
              <p style={{margin:0,fontSize:"0.72rem",color:"#fbbf24",lineHeight:1.5,display:"flex",alignItems:"flex-start",gap:"0.4rem"}}>
                <span style={{flexShrink:0,display:"inline-flex",marginTop:"0.1rem"}}><NavIcon id="alerta" size={15} /></span>
                <span>Tempos registrados manualmente não contam para o ranking.</span>
              </p>
            </div>
            <div style={{display:"flex",gap:"0.6rem",marginTop:"0.4rem"}}>
              <button onClick={()=>setInsertModal(null)} style={{flex:1,padding:"0.65rem",borderRadius:8,border:`1px solid ${t.border}`,background:"transparent",color:t.textMid,fontSize:"0.85rem",fontWeight:600,cursor:"pointer"}}>Cancelar</button>
              <button onClick={submitInsert} style={{flex:1,padding:"0.65rem",borderRadius:8,border:"none",background:t.ac,color:t.mode==="dark"?"#0a0f0b":"#fff",fontSize:"0.85rem",fontWeight:700,cursor:"pointer"}}>Registrar tempo</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

export function Ciclo({ routines, onAddStudiedSec, onAddTimerSec, uid, dataLoaded, isAdmin }) {
  const t = useTheme();
  const [step, setStep]                 = useState(() => loadLS("sf_cycleStep","setup"));
  const [cycleName, setCycleName]       = useState("");
  const [selRoutineId, setSelRoutineId] = useState(routines[0]?.id||null);
  const [selContest, setSelContest]     = useState("");
  const [selCargo, setSelCargo]         = useState(""); // Para PF e PRF
  const [subjects, setSubjects]         = useState([]);
  const [cycles, setCycles]             = useState(() => loadLS("sf_cycles",[]));
  const [activeCycle, setActiveCycle]   = useState(() => loadLS("sf_activeCycle",null));
  const [showStarHelp, setShowStarHelp] = useState(false);
  const [savedContestTemplates, setSavedContestTemplates] = useState(() => loadLS("sf_contest_templates", []));

  // Cargos disponíveis por concurso
  const CARGOS_PF = [
    { id: "pf-agente", label: "Agente de Polícia Federal" },
    { id: "pf-escrivao", label: "Escrivão de Polícia Federal" },
    { id: "pf-papiloscopista", label: "Papiloscopista da Polícia Federal" },
    { id: "pf-delegado", label: "Delegado de Polícia Federal" },
    { id: "pf-administrativo", label: "Agente Administrativo [PF]" },
  ];

  const CARGOS_PCDF = [
    { id: "pcdf-agente", label: "Agente de Polícia - PCDF" },
    { id: "pcdf-delegado", label: "Delegado de Polícia - PCDF" },
  ];

  const CARGOS_PRF = [
    { id: "prf", label: "Agente - PRF" },
    { id: "prf-administrativo", label: "Agente Administrativo - PRF" },
  ];

  function deleteContestTemplate(id) {
    setSavedContestTemplates(prev => {
      const updated = prev.filter(t => t.id !== id);
      saveLS("sf_contest_templates", updated);
      return updated;
    });
  }

  function saveContestTemplate(name, subs) {
    const tpl = { id: Date.now(), name, subjects: subs };
    setSavedContestTemplates(prev => {
      const updated = [...prev.filter(t => t.name !== name), tpl];
      saveLS("sf_contest_templates", updated);
      return updated;
    });
  }

  function loadContestTemplate(tpl) {
    setSubjects(tpl.subjects.map((s,i) => ({
      ...s,
      color: SUBJECT_COLORS[i % SUBJECT_COLORS.length],
      selected: true,
    })));
  }

  // Persist cycle state
  useEffect(() => { saveLS("sf_cycles", cycles); }, [cycles]);
  useEffect(() => { saveLS("sf_activeCycle", activeCycle); }, [activeCycle]);
  useEffect(() => {
    // Only persist "active" step (not "setup"/"subjects" which need re-entry)
    saveLS("sf_cycleStep", step === "active" ? "active" : "setup");
  }, [step]);

  // ── Sincronização com a nuvem (Supabase) ──────────────────────────────────
  // A nuvem é a fonte da verdade; o localStorage é só cache. Regras (depois de
  // 02/11/2026, quando dados velhos guardados num navegador apagaram um ciclo real):
  //  1. O ciclo só aparece e só é gravado depois de ler a nuvem (cloudState "ready").
  //  2. Se a leitura falhar, nada é gravado: aparece o erro com "Tentar de novo".
  //  3. Toda gravação é condicional: só vale se a nuvem ainda estiver na versão que
  //     este aparelho leu (updated_at). Se outro aparelho/aba gravou antes, não
  //     sobrescreve — carrega a versão mais nova e avisa.
  const cloudCycleSynced = useRef(false);
  const [cloudState, setCloudState] = useState(uid ? "loading" : "ready");   // loading | ready | error
  const [cloudRetry, setCloudRetry] = useState(0);
  const [cloudRev, setCloudRev]     = useState(0);       // muda quando a versão da nuvem substitui a local (remonta o CicloAtivo)
  const cloudStampRef = useRef(null);                     // updated_at da versão da nuvem que este aparelho conhece
  const cloudJsonRef  = useRef(null);                     // conteúdo dessa versão (evita regravar o que já está lá)
  const cloudQueueRef = useRef(Promise.resolve());        // leituras/gravações em fila, uma por vez
  const latestRef     = useRef({ cycles, activeCycle });
  latestRef.current = { cycles, activeCycle };

  async function fetchCloudCycles() {
    const { data, error } = await sb.from("cycles").select("data, updated_at").eq("user_id", uid).maybeSingle();
    if (error) throw error;
    return data;                                          // null = ainda não existe registro na nuvem
  }
  function applyRemote(row) {
    const remote = (row && row.data) || {};
    const val = { cycles: remote.cycles || [], activeCycle: remote.activeCycle || null };
    cloudStampRef.current = row.updated_at;
    cloudJsonRef.current  = JSON.stringify(val);
    setCycles(val.cycles);
    setActiveCycle(val.activeCycle);
    setStep(val.activeCycle ? "active" : "setup");
    setCloudRev(r => r + 1);
  }
  function pushCycles() {
    const forUid = uid;
    cloudQueueRef.current = cloudQueueRef.current.then(async () => {
      if (!forUid || !cloudCycleSynced.current) return;
      const val = latestRef.current;
      const json = JSON.stringify(val);
      if (json === cloudJsonRef.current) return;
      const now = new Date().toISOString();
      try {
        const res = cloudStampRef.current
          ? await sb.from("cycles").update({ data: val, updated_at: now }).eq("user_id", forUid).eq("updated_at", cloudStampRef.current).select("updated_at")
          : await sb.from("cycles").insert({ user_id: forUid, data: val, updated_at: now }).select("updated_at");
        if (res.error && res.error.code !== "23505") { console.error("Ciclo: gravação na nuvem falhou:", res.error); return; }
        if (!res.error && res.data && res.data.length) {
          cloudStampRef.current = res.data[0].updated_at;
          cloudJsonRef.current  = json;
          return;
        }
        // Conflito: a nuvem mudou desde a última leitura (outro aparelho ou aba). Não sobrescreve.
        const row = await fetchCloudCycles();
        if (!row) { cloudStampRef.current = null; cloudJsonRef.current = null; return; }
        applyRemote(row);
        appAlert("Seu ciclo foi alterado em outro aparelho ou aba. Carregamos a versão mais recente para não perder nada.", { title: "Ciclo atualizado" });
      } catch (e) { console.error("Ciclo: gravação na nuvem falhou:", e); }
    });
    return cloudQueueRef.current;
  }

  // Se o uid mudar (logout, ou troca de conta no mesmo navegador), reseta o
  // estado local pra não vazar dados de uma conta pra outra.
  const prevUidRef = useRef(uid);
  useEffect(() => {
    if (prevUidRef.current === uid) return;
    prevUidRef.current = uid;
    cloudCycleSynced.current = false;
    cloudStampRef.current = null;
    cloudJsonRef.current = null;
    setCloudState(uid ? "loading" : "ready");
    if (!uid) { setCycles([]); setActiveCycle(null); setStep("setup"); }
  }, [uid]);

  useEffect(() => {
    if (!uid || !dataLoaded || cloudCycleSynced.current) return;
    let cancelled = false;
    setCloudState("loading");
    (async () => {
      try {
        const row = await fetchCloudCycles();
        if (cancelled) return;
        if (row) applyRemote(row);                        // a nuvem sempre ganha, mesmo vazia
        cloudCycleSynced.current = true;
        setCloudState("ready");
        // Sem registro na nuvem, mas com ciclo neste navegador (contas antigas): sobe.
        if (!row && (latestRef.current.cycles.length || latestRef.current.activeCycle)) pushCycles();
      } catch (e) {
        if (cancelled) return;
        console.error("Ciclo: leitura da nuvem falhou:", e);
        setCloudState("error");                           // sem saber o que há na nuvem, não grava nada
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid, dataLoaded, cloudRetry]);

  const cloudCycleDebounce = useRef(null);
  useEffect(() => {
    if (!uid || !dataLoaded || !cloudCycleSynced.current) return;
    clearTimeout(cloudCycleDebounce.current);
    cloudCycleDebounce.current = setTimeout(pushCycles, 800);
    return () => clearTimeout(cloudCycleDebounce.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cycles, activeCycle, uid, dataLoaded]);

  // Ao esconder/fechar a aba: envia na hora o que estiver pendente do debounce.
  // Ao voltar para a aba: se outro aparelho gravou uma versão mais nova e aqui não
  // há nada pendente (nem cronômetro rodando), carrega a versão nova.
  useEffect(() => {
    if (!uid || !dataLoaded) return;
    const flush = () => {
      if (!cloudCycleSynced.current) return;
      clearTimeout(cloudCycleDebounce.current);
      pushCycles();
    };
    const refresh = () => {
      cloudQueueRef.current = cloudQueueRef.current.then(async () => {
        if (!cloudCycleSynced.current || loadLS("sf_timerRunning", false)) return;
        try {
          const row = await fetchCloudCycles();
          if (row && row.updated_at !== cloudStampRef.current && JSON.stringify(latestRef.current) === cloudJsonRef.current) applyRemote(row);
        } catch {}
      });
    };
    const onVisibility = () => { if (document.visibilityState === "hidden") flush(); else refresh(); };
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pagehide", flush);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pagehide", flush);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid, dataLoaded]);

  // On mount: if we have a saved active cycle, go straight to active view
  useEffect(() => {
    if (activeCycle && step === "active") {
      // already set correctly
    } else if (activeCycle && step === "setup") {
      setStep("active");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dependências mantidas como estavam (mudar alteraria quando o efeito roda)
  }, []);

  const selRoutine = routines.find(r=>r.id===selRoutineId);
  const totalStudyMin = selRoutine
    ? selRoutine.slots.filter(s=>s.isStudy).reduce((acc,s)=>acc+(timeToMinutes(s.end)-timeToMinutes(s.start))*s.days.length,0)
    : 0;

  function loadContest(id, cargo = null) {
    setSelContest(id);
    // Se PF ou PRF sem cargo, não carrega matérias ainda
    if ((id === "pf" || id === "prf" || id === "pcdf") && !cargo) {
      setSelCargo("");
      setSubjects([]);
      return;
    }
    // Usa o cargo se fornecido, senão usa o id direto
    const templateId = cargo || id;
    const subs = CONTEST_SUBJECTS[templateId] || [];
    setSubjects(subs.map((s,i)=>({...s, color:SUBJECT_COLORS[i%SUBJECT_COLORS.length], selected:false, stars:0})));
    if (cargo) setSelCargo(cargo);
  }

  function buildCycle() {
    const selected = subjects.filter(s=>s.selected);
    if (!selected.length || !totalStudyMin) return;

    // Score: weight × difficulty. Stars = experience level. More stars = knows more = less time.
    // 0★ = never studied = max time (diff=5), 5★ = expert = min time (diff=1)
    const scores   = selected.map(s => { const diff = Math.max(1, 5 - s.stars + (s.edital ? -1 : 0)); return s.weight * diff; });
    const scoreSum = scores.reduce((a,b)=>a+b,0);

    // Allocate total hours in 30-min units, no cap per subject
    const target30 = Math.round(totalStudyMin / 30);
    let blocks = selected.map((_,i) => Math.max(1, Math.round((scores[i]/scoreSum)*target30)));

    // Fine-tune to hit exactly target30
    let diff = target30 - blocks.reduce((a,b)=>a+b,0);
    while (diff !== 0) {
      // Sort by who needs the most adjustment proportionally
      const order = scores.map((_,i)=>i).sort((a,b)=>scores[b]-scores[a]);
      for (const i of order) {
        if (diff === 0) break;
        if (diff > 0) { blocks[i]++; diff--; }
        else if (blocks[i] > 1) { blocks[i]--; diff++; }
      }
    }

    // Expand each subject into sessions of max 4×30=120min each
    // e.g. 10 units of Trânsito → [4,4,2] sessions
    const pools = selected.map((s,i) => {
      const sessions = [];
      let rem = blocks[i];
      while (rem > 0) {
        const take = Math.min(rem, 4);
        sessions.push({ ...s, blockMin: take*30, studiedSec: 0 });
        rem -= take;
      }
      return sessions;
    });

    // Interleave: round-robin across subjects by session count (most sessions first)
    // This guarantees no subject repeats back-to-back unless unavoidable
    const interleaved = [];
    const queues = pools.map((p,i)=>({sessions:[...p], score:scores[i], idx:i}))
                        .filter(q=>q.sessions.length>0)
                        .sort((a,b)=>b.sessions.length-a.sessions.length);

    while (queues.some(q=>q.sessions.length>0)) {
      // Pick the queue with most remaining that isn't the same as last placed
      const lastName = interleaved.length > 0 ? interleaved[interleaved.length-1].name : null;
      const available = queues.filter(q=>q.sessions.length>0);
      // Prefer different subject from last
      const candidates = available.filter(q=>q.sessions[0].name !== lastName);
      const pick = (candidates.length > 0 ? candidates : available)
        .reduce((best,q) => q.sessions.length > best.sessions.length ? q : best);
      interleaved.push(pick.sessions.shift());
    }

    const cycle = {
      id: Date.now(),
      name: cycleName || `Ciclo ${cycles.length+1}`,
      contest: selContest,
      cargo: selCargo || null,
      totalMin: interleaved.reduce((a,s)=>a+s.blockMin, 0),
      subjects: interleaved,
      originalSubjects: subjects.map(s=>({ name:s.name, weight:s.weight, stars:s.stars||0, edital:s.edital||false, selected:s.selected||false })),
    };
    setCycles(prev=>[...prev,cycle]);
    setActiveCycle(cycle);
    setStep("active");
  }

  function handleSaveTime(updatedSubjects) {
    if (!activeCycle) return;
    const updated = {...activeCycle, subjects:updatedSubjects};
    setActiveCycle(updated);
    setCycles(prev=>prev.map(c=>c.id===updated.id?updated:c));
  }

  // ── AGUARDANDO A NUVEM ─────────────────────────────────────────────────────
  // Nada do ciclo aparece (nem o cronômetro) antes de saber o que está na nuvem.
  if (uid && cloudState !== "ready") {
    return (
      <div style={{ background:t.bgCard, border:`1px solid ${t.border}`, borderRadius:14, padding:"2rem 1.5rem", textAlign:"center", maxWidth:520, margin:"2rem auto" }}>
        {cloudState === "error" ? (
          <>
            <div style={{ fontSize:"1rem", fontWeight:700, color:t.text, marginBottom:"0.5rem" }}>Não foi possível carregar seu ciclo</div>
            <div style={{ fontSize:"0.85rem", color:t.textDim, lineHeight:1.5, marginBottom:"1.2rem" }}>
              Verifique sua conexão. Seu ciclo está guardado na nuvem e nada foi alterado.
            </div>
            <button onClick={() => setCloudRetry(n => n + 1)}
              style={{ background:t.ac, border:"none", borderRadius:8, padding:"0.6rem 1.4rem", color: t.mode === "dark" ? "#0a0f0b" : "#fff", fontWeight:700, fontSize:"0.85rem", cursor:"pointer" }}>
              Tentar de novo
            </button>
          </>
        ) : (
          <div style={{ fontSize:"0.9rem", color:t.textDim }}>Carregando seu ciclo…</div>
        )}
      </div>
    );
  }

  // ── ACTIVE ────────────────────────────────────────────────────────────────
  if (step==="active" && activeCycle) {
    return <CicloAtivo
      key={`${activeCycle.id}-${cloudRev}`}
      uid={uid}
      isAdmin={isAdmin}
      cycle={activeCycle}
      cargoLabel={[...CARGOS_PF, ...CARGOS_PRF, ...CARGOS_PCDF].find(c => c.id === activeCycle.cargo)?.label}
      onCalendarTime={(name, sec) => splitByMidnight(sec).forEach(pt => calAddStudy(uid, name, pt.sec, pt.at))}
      onEdit={async ()=>{
        if(!(await appConfirm(`O progresso atual de "${activeCycle.name}" será perdido e o ciclo será reiniciado com os novos ajustes.`, { title:"Editar o ciclo?", confirmText:"Editar ciclo", icon:"editar" }))) return;
        setSelContest(activeCycle.contest || "");
        setSelCargo(activeCycle.cargo || "");
        setCycleName(activeCycle.name || "");
        // Rebuild unique subjects preserving stars/edital/selected from stored originalSubjects if available
        const orig = activeCycle.originalSubjects;
        if (orig && orig.length > 0) {
          setSubjects(orig.map((s,i)=>({
            ...s,
            color: SUBJECT_COLORS[i % SUBJECT_COLORS.length],
          })));
        } else {
          // Fallback: dedupe from interleaved sessions
          const seen = new Set();
          const deduped = (activeCycle.subjects||[]).filter(s=>{ if(seen.has(s.name)) return false; seen.add(s.name); return true; });
          const base = CONTEST_SUBJECTS[activeCycle.cargo] || CONTEST_SUBJECTS[activeCycle.contest] || [];
          if (base.length > 0) {
            setSubjects(base.map((s,i)=>{
              const found = deduped.find(d=>d.name===s.name);
              return { ...s, color:SUBJECT_COLORS[i%SUBJECT_COLORS.length], selected:!!found, stars:found?.stars||0, edital:found?.edital||false };
            }));
          } else {
            setSubjects(deduped.map((s,i)=>({
              name:s.name, weight:s.weight||1, color:SUBJECT_COLORS[i%SUBJECT_COLORS.length],
              selected:true, stars:s.stars||0, edital:s.edital||false,
            })));
          }
        }
        setActiveCycle(null);
        setStep("subjects");
      }}
      onNew={()=>{setActiveCycle(null);setStep("setup");setCycleName("");setSelContest("");setSubjects([]);}}
      onDelete={async ()=>{
        if(!(await appConfirm(`O progresso de "${activeCycle.name}" será perdido.`, { title:"Excluir o ciclo?", confirmText:"Excluir", danger:true }))) return;
        setCycles(prev=>prev.filter(c=>c.id!==activeCycle.id));
        setActiveCycle(null);
        setStep("setup");
      }}
      onSaveTime={handleSaveTime}
      onAddStudiedSec={onAddStudiedSec}
      onAddTimerSec={onAddTimerSec}
      theme={t}
    />;
  }

  // ── SUBJECTS ──────────────────────────────────────────────────────────────
  if (step==="subjects") {
    const canCreate = subjects.some(s=>s.selected);
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:"1.2rem"}}>
          <div>
            <TacEyebrow color={t.textDim} style={{ marginBottom:"0.4rem" }}>Novo ciclo</TacEyebrow>
            <h2 style={{fontSize:"1.6rem",fontWeight:800,margin:0,color:t.text,letterSpacing:"-0.03em"}}>Matérias do Ciclo</h2>
          </div>
          <button onClick={()=>setStep("setup")} style={{background:"transparent",border:`1px solid ${t.border}`,borderRadius:8,padding:"0.5rem 1rem",color:t.textDim,fontSize:"0.78rem",cursor:"pointer"}}>← Voltar</button>
        </div>
        <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:12,padding:"0.9rem 1.4rem",marginBottom:"1rem",display:"flex",gap:"1.5rem",alignItems:"center"}}>
          <div><p style={{color:t.textDim,fontSize:"0.68rem",textTransform:"uppercase",margin:"0 0 0.15rem"}}>Horas disponíveis</p><p style={{color:t.ac,fontSize:"1.2rem",fontWeight:800,margin:0}}>{minutesToHuman(totalStudyMin)}</p></div>
          <div style={{width:1,height:32,background:t.border}}/>
          <p style={{color:t.textFaint,fontSize:"0.78rem",margin:0,flex:1}}>Marque as matérias e defina a experiência. Mais estrelas = mais tempo alocado no ciclo.</p>
        </div>
        {selContest==="outros" ? (
          <OtrosSubjectBuilder subjects={subjects} setSubjects={setSubjects} theme={t}
            savedTemplates={savedContestTemplates} onSaveTemplate={saveContestTemplate} onLoadTemplate={loadContestTemplate} onDeleteTemplate={deleteContestTemplate} />
        ) : (
        <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:12,overflow:"hidden",marginBottom:"1rem"}}>
          <div style={{display:"grid",gridTemplateColumns:"2.5rem 1fr 8rem 10rem 5rem 6rem",padding:"0.6rem 1.2rem",borderBottom:`1px solid ${t.borderIn}`}}>
            {["","Matéria","Completou edital?","Experiência","Peso","Horas"].map((h,i)=>(
              <span key={i} style={{fontSize:"0.66rem",color:t.textFaint,textTransform:"uppercase",letterSpacing:"0.1em",display:"flex",alignItems:"center",gap:4,textAlign:i===5?"right":"left"}}>
                {h}
                {i===3 && <span onClick={()=>setShowStarHelp(true)} style={{cursor:"pointer",width:14,height:14,borderRadius:"50%",border:`1px solid ${t.border}`,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:"0.55rem",color:t.textGhost,marginLeft:6,flexShrink:0}}>?</span>}
              </span>
            ))}
          </div>
          {showStarHelp && <StarLegendModal onClose={()=>setShowStarHelp(false)} theme={t}/>}
          {subjects.map((s,i)=>{
            // Preview hours for this subject
            const selSubs = subjects.filter(x=>x.selected);
            const scores  = selSubs.map(x=>x.weight*(Math.max(1,5-x.stars+(x.edital?-1:0))));
            const scoreSum= scores.reduce((a,b)=>a+b,0)||1;
            const myScore = s.selected ? s.weight*(Math.max(1,5-s.stars+(s.edital?-1:0))) : 0;
            const rawMin  = totalStudyMin > 0 ? (myScore/scoreSum)*totalStudyMin : 0;
            const previewMin = s.selected ? Math.max(30, Math.round(rawMin/30)*30) : 0;

            return (
            <div key={i} style={{display:"grid",gridTemplateColumns:"2.5rem 1fr 8rem 10rem 5rem 6rem",padding:"0.65rem 1.2rem",borderBottom:i<subjects.length-1?`1px solid ${t.borderIn}`:"none",alignItems:"center",background:s.selected?"transparent":t.bgInner,opacity:s.selected?1:0.55}}>
              <input type="checkbox" checked={s.selected} onChange={e=>setSubjects(p=>p.map((x,j)=>j===i?{...x,selected:e.target.checked}:x))} style={{width:16,height:16,accentColor:t.ac,cursor:"pointer"}}/>
              <div style={{display:"flex",alignItems:"center",gap:"0.5rem"}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:s.color,flexShrink:0}}/>
                <span style={{fontSize:"0.84rem",color:s.selected?t.textMid:t.textFaint,fontWeight:s.selected?600:400}}>{s.name}</span>
              </div>
              {/* Completou edital toggle */}
              <div style={{display:"flex",alignItems:"center",gap:4,opacity:s.selected?1:0.25,pointerEvents:s.selected?"auto":"none"}}>
                <span style={{fontSize:"0.7rem",color:t.textDim}}>Não</span>
                <div onClick={()=>{
                  if(!s.selected) return;
                  const newVal = !s.edital;
                  setSubjects(p=>{
                    const updated = p.map((x,j)=>j===i?{...x,edital:newVal}:x);
                    // auto-advance: select next unselected if marking edital=true
                    if(newVal){
                      const nextUnsel = updated.findIndex((x,j)=>j>i&&!x.selected);
                      if(nextUnsel>=0) return updated.map((x,j)=>j===nextUnsel?{...x,selected:true}:x);
                    }
                    return updated;
                  });
                }} style={{width:32,height:18,borderRadius:99,background:s.edital?t.ac:t.bgInner,border:`1px solid ${s.edital?t.ac:t.border}`,cursor:s.selected?"pointer":"default",position:"relative",transition:"background 0.15s",flexShrink:0}}>
                  <div style={{width:12,height:12,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:s.edital?17:3,transition:"left 0.15s"}}/>
                </div>
                <span style={{fontSize:"0.7rem",color:s.edital?t.ac:t.textDim}}>Sim</span>
              </div>

              <div style={{opacity:s.selected?1:0.3,pointerEvents:s.selected?"auto":"none"}}>
                <StarRating value={s.stars} onChange={v=>setSubjects(p=>p.map((x,j)=>j===i?{...x,stars:v,selected:true}:x))}/>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:2,opacity:s.selected?1:0.4}}>
                <input
                  type="number" min={1} max={999}
                  value={s.weight}
                  onChange={e=>{
                    const v=parseInt(e.target.value)||1;
                    setSubjects(p=>p.map((x,j)=>j===i?{...x,weight:Math.max(1,Math.min(999,v))}:x));
                  }}
                  style={{width:44,background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:6,padding:"0.15rem 0.3rem",fontSize:"0.78rem",color:t.textMid,fontWeight:700,textAlign:"center",outline:"none"}}
                />
                <span style={{fontSize:"0.72rem",color:t.textFaint}}>q</span>
              </div>
              <span style={{fontSize:"0.82rem",fontWeight:700,color:s.selected?t.ac:t.textGhost,textAlign:"right"}}>
                {s.selected&&previewMin>0 ? minutesToHuman(previewMin) : "—"}
              </span>
            </div>
            );
          })}
        </div>
        )}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{color:t.textFaint,fontSize:"0.78rem"}}>{subjects.filter(s=>s.selected).length} matéria(s) selecionadas</span>
          <button onClick={buildCycle} disabled={!canCreate}
            style={{background:canCreate?t.ac:t.bgInner,color:canCreate?(t.mode==="dark"?"#0a0f0b":"#fff"):t.textFaint,border:"none",borderRadius:8,padding:"0.7rem 1.5rem",fontWeight:700,fontSize:"0.85rem",cursor:canCreate?"pointer":"not-allowed"}}>
            Gerar ciclo ({subjects.filter(s=>s.selected).length} matérias) →
          </button>
        </div>
      </div>
    );
  }

  // ── SETUP ─────────────────────────────────────────────────────────────────
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:"1.5rem"}}>
        <div>
          <TacEyebrow color={t.textDim} style={{ marginBottom:"0.4rem" }}>Módulo</TacEyebrow>
          <h2 style={{fontSize:"1.6rem",fontWeight:800,margin:0,color:t.text,letterSpacing:"-0.03em"}}>Ciclo de Estudos</h2>
        </div>
      </div>
      {cycles.length>0&&(
        <div style={{marginBottom:"1.5rem"}}>
          <TacEyebrow color={t.textDim} style={{ marginBottom:"0.6rem" }}>Meus ciclos</TacEyebrow>
          <div style={{display:"flex",gap:"0.6rem",flexWrap:"wrap"}}>
            {cycles.map(c=>(
              <div key={c.id} style={{position:"relative",display:"inline-block"}}>
                <button onClick={()=>{setActiveCycle(c);setStep("active");}} style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:10,padding:"0.7rem 2.4rem 0.7rem 1.1rem",cursor:"pointer",textAlign:"left"}}>
                  <p style={{margin:0,fontWeight:700,color:t.text,fontSize:"0.85rem"}}>{c.name}</p>
                  <p style={{margin:"0.15rem 0 0",fontSize:"0.7rem",color:t.textDim,textTransform:"uppercase"}}>{c.contest} · {c.subjects.length} matérias · {minutesToHuman(c.totalMin)}/sem</p>
                </button>
                <button onClick={async e=>{
                  e.stopPropagation();
                  if(!(await appConfirm(`O ciclo "${c.name}" e o progresso dele serão apagados.`, { title:"Excluir ciclo?", confirmText:"Excluir", danger:true }))) return;
                  setCycles(prev=>prev.filter(x=>x.id!==c.id));
                  if(activeCycle?.id===c.id){setActiveCycle(null);setStep("setup");}
                }} style={{position:"absolute",top:4,right:4,background:"transparent",border:"none",color:t.textGhost,cursor:"pointer",fontSize:"0.75rem",padding:"0.2rem 0.35rem",borderRadius:4,lineHeight:1}}
                  title="Excluir ciclo">✕</button>
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{background:t.bgCard,border:`1px solid ${t.border}`,borderRadius:16,padding:"1.5rem"}}>
        <h3 style={{fontSize:"1rem",fontWeight:700,color:t.text,margin:"0 0 1.2rem"}}>Criar novo ciclo</h3>
        <div style={{marginBottom:"1rem"}}>
          <label style={{fontSize:"0.72rem",color:t.textDim,display:"block",marginBottom:"0.3rem",textTransform:"uppercase"}}>Nome do ciclo</label>
          <input value={cycleName} onChange={e=>setCycleName(e.target.value)} placeholder="ex: Ciclo PRF 2026"
            style={{width:"100%",background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:8,padding:"0.6rem 0.8rem",color:t.text,fontSize:"0.88rem",outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div style={{marginBottom:"1rem"}}>
          <label style={{fontSize:"0.72rem",color:t.textDim,display:"block",marginBottom:"0.3rem",textTransform:"uppercase"}}>Rotina de estudos</label>
          {routines.length===0 ? (
            <div style={{background:t.bgInner,border:`1px solid ${t.border}`,borderRadius:8,padding:"0.8rem",display:"flex",alignItems:"center",gap:"0.6rem"}}>
              <span style={{display:"inline-flex",color:"#fbbf24"}}><NavIcon id="alerta" size={17} /></span><p style={{margin:0,fontSize:"0.8rem",color:t.textFaint}}>Crie uma rotina na aba <strong style={{color:t.ac}}>Rotina</strong> primeiro.</p>
            </div>
          ):(
            <div style={{display:"flex",flexDirection:"column",gap:"0.4rem"}}>
              {routines.map(r=>{
                const rMin=r.slots.filter(s=>s.isStudy).reduce((acc,s)=>acc+(timeToMinutes(s.end)-timeToMinutes(s.start))*s.days.length,0);
                return (
                  <button key={r.id} onClick={()=>setSelRoutineId(r.id)} style={{background:selRoutineId===r.id?t.acDim:t.bgInner,border:`1px solid ${selRoutineId===r.id?t.acBorder:t.border}`,borderRadius:8,padding:"0.7rem 1rem",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontWeight:selRoutineId===r.id?700:400,color:selRoutineId===r.id?t.ac:t.textMid,fontSize:"0.85rem"}}>{r.name}</span>
                    <span style={{fontSize:"0.75rem",color:selRoutineId===r.id?t.ac:t.textDim}}>{rMin>0?minutesToHuman(rMin)+"/sem":"Sem horários"}</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
        <div style={{marginBottom:"1.2rem"}}>
          <label style={{fontSize:"0.72rem",color:t.textDim,display:"block",marginBottom:"0.5rem",textTransform:"uppercase"}}>Concurso</label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"0.6rem"}}>
            {CONTEST_LIST.map(c=>(
              <button key={c.id} onClick={()=>loadContest(c.id)}
                style={{background:selContest===c.id?c.color+"18":t.bgInner,border:`2px solid ${selContest===c.id?c.color:t.border}`,borderRadius:12,padding:"0.9rem 0.6rem",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:"0.4rem",position:"relative",transition:"all 0.12s",minHeight:110}}>
                {selContest===c.id&&<div style={{position:"absolute",top:5,right:6,width:16,height:16,borderRadius:3,background:c.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"0.58rem",fontWeight:900,color:"#fff"}}>✓</div>}
                <ContestEmblem id={c.id} size={44} />
                <div style={{textAlign:"center"}}>
                  <p style={{margin:0,fontWeight:700,color:selContest===c.id?c.color:t.textMid,fontSize:"0.82rem"}}>{c.label}</p>
                  <p style={{margin:0,fontSize:"0.6rem",color:t.textDim,lineHeight:1.3}}>{c.full}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
        
        {/* Dropdown de cargos para PF, PRF e PCDF */}
        {(selContest === "pf" || selContest === "prf" || selContest === "pcdf") && (
          <div style={{marginBottom:"1.2rem"}}>
            <label style={{fontSize:"0.72rem",color:t.textDim,display:"block",marginBottom:"0.5rem",textTransform:"uppercase"}}>
              Cargo
            </label>
            <select 
              value={selCargo} 
              onChange={e => loadContest(selContest, e.target.value)}
              style={{
                width:"100%",
                background:t.bgInner,
                border:`1px solid ${t.border}`,
                borderRadius:8,
                padding:"0.75rem 1rem",
                color:t.text,
                fontSize:"0.85rem",
                outline:"none",
                cursor:"pointer",
                colorScheme:t.mode
              }}>
              <option value="">Selecione o cargo...</option>
              {(selContest === "pf" ? CARGOS_PF : selContest === "pcdf" ? CARGOS_PCDF : CARGOS_PRF).map(cargo => (
                <option key={cargo.id} value={cargo.id}>{cargo.label}</option>
              ))}
            </select>
          </div>
        )}
        
        <button onClick={()=>{if(selRoutine&&selContest&&totalStudyMin>0&&((selContest!=="pf"&&selContest!=="prf"&&selContest!=="pcdf")||selCargo))setStep("subjects");}}
          disabled={!selRoutine||!selContest||totalStudyMin===0||((selContest==="pf"||selContest==="prf"||selContest==="pcdf")&&!selCargo)}
          style={{width:"100%",background:selRoutine&&selContest&&totalStudyMin>0&&((selContest!=="pf"&&selContest!=="prf"&&selContest!=="pcdf")||selCargo)?t.ac:t.bgInner,color:selRoutine&&selContest&&totalStudyMin>0&&((selContest!=="pf"&&selContest!=="prf"&&selContest!=="pcdf")||selCargo)?(t.mode==="dark"?"#0a0f0b":"#fff"):t.textFaint,border:"none",borderRadius:8,padding:"0.75rem",fontWeight:700,fontSize:"0.88rem",cursor:selRoutine&&selContest&&totalStudyMin>0&&((selContest!=="pf"&&selContest!=="prf"&&selContest!=="pcdf")||selCargo)?"pointer":"not-allowed"}}>
          Selecionar matérias →
        </button>
        {selRoutine&&totalStudyMin===0&&<p style={{color:t.textFaint,fontSize:"0.72rem",textAlign:"center",margin:"0.4rem 0 0"}}>Rotina sem horários de estudo cadastrados</p>}
      </div>
    </div>
  );
}
